
import BookingSdnBanner from "@/app/ui/components/booking-sdn-banner/index.vue";
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Options } from "vue-class-component";
import {
  CreateBookingV4,
  ErrorBookingV4,
  BookingTabV4,
  ReceiptFormatV4,
  FormCompletionSectionKeyV4,
  FormCompletionSectionStateV4,
  FormCompletionSectionBookingV4,
  FormCompletionFieldRowV4,
  FormCompletionPanelItemV4,
  PaymentMethodBookingV4,
  PaymentMethodOptionV4,
  PaymentMethodV4,
  PageMetaBookingV4,
  SenderBookingV4,
  CommodityBookingV4,
  CommodityCategoryV4,
  PieceBookingV4,
  CommodityCiplBookingV4,
  HwsThresholdConfig,
  ProductBookingV4,
  ReferenceChipV4,
  ProtectionPackingBookingV4,
  ChargeableWeightBreakdownV4,
  SupportingDocBookingV4,
  DocInternationalBookingV4,
  ErrorPiecesBookingV4,
  ReceiverBookingV4,
  FailedBookingData,
  SuccessBookingV4,
  SavedPackageBookingV4
} from "@/domain/entities/BookingV4";
import { RequestInternationalDocumentDetail } from "@/domain/entities/InternationalDocument";
import { DistrictData } from "@/domain/entities/Location";
import { Commodity } from "@/domain/entities/Commodity";
import {
  ManualBookingV4Retail,
  GetEstimationPriceV4,
  // GetBookingVoucherListV4,
  // ValidateBookingVoucherCodeV4,
  // IssueVoucherBookingOtpRequestV4,
  // CancelVoucherBookingReserveRequestV4,
  RequestListCommodityV4,
  ProductConfigurationRuleRequestParamsV4,
  CIPLTypeV4
} from "@/data/payload/api/BookingV4Request";
import {
  // BookingVoucherItem,
  // BookingVoucherPagination,
  // BookingVoucherList,
  EstimationPrice,
  PrintDataEntitas,
  // WoodpackingEligibility,
  InsuranceTypeDeliveryData
} from "@/domain/entities/Booking";
// import { WoodpackingEligibility } from "@/domain/entities/Booking";
import generateCommercialInvoiceV2 from "@/app/ui/modules/commercial-invoice-v2";
import { ProductConfigurationRule } from "@/domain/entities/Product";
import {
  ShipmentBookingDetail,
  SttAdjustmentRule
} from "@/domain/entities/ShipmentBooking";
import { FraudStatus, SuccessBooking } from "@/domain/entities/CreateBookingV3";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import HeaderBookingV4 from "./components/header/index.vue";
import SenderSectionV4 from "./components/detail-sender/index.vue";
import ReceiverSectionV4 from "./components/detail-receiver/index.vue";
import ReferenceNumberV4 from "./components/reference-number/index.vue";
import { AccountTypeV4 } from "./components/reference-number/validationReferenceNumber";
import FormCompletionPanel from "./components/form-completion/index.vue";
import PaymentMethodSelectorV4 from "./components/footer-v2/payment/index.vue";
// import SectionVoucherV4 from "./components/section-voucher.vue";
// import OTPVoucherModalV4 from "./components/otp-voucher-modal/index.vue";
import GoodsPackageV4 from "./components/goods-package/index.vue";
import ProductCardListV4 from "./components/jenis-pengiriman/product-card-list.vue";
import ProtectionPackingSummary from "./components/protection-packing-summary/index.vue";
import BookingStickyFooterV4 from "./components/footer-v2/index.vue";
import TotalTarifSectionV4 from "./components/footer-v2/components/check-tariff.vue";
import SupportingDocSectionV4 from "./components/supporting-documents/index.vue";
// import ModalListVoucher from "./components/modal-list-voucher/index.vue";
import ModalSuccessReceipt from "../../print-receipt-v2/components/modal-success-receipt.vue";
import InvoicePdfA4 from "../../print-receipt-v2/components/invoice/InvoicePdfA4.vue";
import InvoicePdfStruk from "../../print-receipt-v2/components/invoice/InvoicePdfStruk.vue";
import { countries as COUNTRY_OPTIONS } from "@/app/infrastructures/misc/BulkData";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { BookingController } from "@/app/ui/controllers/BookingController";
// import { InvoiceLimitController } from "@/app/ui/controllers/InvoiceLimitController";
import { BookingV4Controller } from "@/app/ui/controllers/BookingV4Controller";
import { ProductController } from "@/app/ui/controllers/ProductController";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { InternationalDocumentController } from "@/app/ui/controllers/InternationalDocumentController";
import {
  ApiRequestList,
  ErrorMessageEntities
} from "@/domain/entities/MainApp";
import {
  CLIENT_ERROR,
  parsingErrorResponse,
  formatPriceRP,
  formatPriceRM,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import {
  getCurrencyByCountryCode,
  isMalaysiaDistrict
} from "@/app/infrastructures/misc/common-library/MalaysiaDistrictFieldRules";
import { configPrice } from "@/app/infrastructures/misc/common-library/modules/Price";
import { getRoundedChargeableWeightByRules } from "@/app/infrastructures/misc/common-library/getRoundedChargeableWeightByRules";
import { isEligibleForMaxVolumeWeightDiscount } from "@/app/infrastructures/misc/common-library/IsEligibleForMaxVolumeWeightDiscount";
import { volumeWeightForProduct } from "../booking-utils";
import { debounce } from "lodash";
import { PosterProduct } from "@/domain/entities/CreateBookingV3";
import {
  ComodityProductPoster,
  PayloadPosterProduct
} from "@/domain/entities/Booking";
import { ProductCardItem } from "@/domain/entities/BookingV4";
import { applyRecommendationOrder } from "../create-booking-v3/utils/applyRecommendationOrder";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { FlagsPermissionBookingV4 } from "@/feature-flags/flag-booking-v4";
import { PrintReceiptController } from "@/app/ui/controllers/PrintReceiptController";
import ModalSuccessBookingV4 from "../create-booking-v4/components/modal-booking/modal-success.vue";
import ModalFailedBookingV4 from "../create-booking-v4/components/modal-booking/modal-failed.vue";
import bulkLabelResiThermal from "../../bulk-print-resi/modules/bulk-label-resi-thermal";
import bulkLabelResiPdf from "../../bulk-print-resi/modules/bulk-label-resi-pdf";
import { resolveSelection } from "../create-booking-v3/utils/resolveDefaultProductName";
import ModalPreviewInvoice from "../create-booking-v3/components/modal-booking/modal-preview-invoice.vue";
import JsBarcode from "jsbarcode";
import {
  PrintDetailRequest,
  // WoodpackingEligibilityQuery
} from "@/data/payload/api/BookingRequest";
import { HeavyWeightSurchargeController } from "@/app/ui/controllers/HeavyWeightSurchargeController";
import { HeavyWeightSurchargeData } from "@/domain/entities/HeavyWeightSurcharge";
import { CodConfigurationController } from "@/app/ui/controllers/CodConfigurationController";
import { DetailCodConfigurationRetail } from "@/domain/entities/CodConfiguration";
import { InsuranceController } from "@/app/ui/controllers/InsuranceController";
import { Insurance } from "@/domain/entities/Insurance";
import { DutyTaxConfigurationController } from "@/app/ui/controllers/DutyTaxConfigurationController";
import {
  DutyTaxResolveItemInput,
  DutyTaxResolveResult
} from "@/domain/entities/DutyTaxConfiguration";
import { Invoice, PRINT_RECEIPT_KEY } from "@/domain/entities/PrintReceipt";
import { nextTick } from "vue";
import { ActivityRequest } from "@/data/payload/api/PrintReceiptApiRequest";
import { shouldSubmitBookingOnEnter } from "./utils/submit-on-enter";
import { getToken } from "@/app/infrastructures/misc/Cookies";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";

type BookingTabV4Value = typeof BookingTabV4[keyof typeof BookingTabV4];
type ReceiptFormatV4Value = typeof ReceiptFormatV4[keyof typeof ReceiptFormatV4];
type FormCompletionSectionKeyV4Value = typeof FormCompletionSectionKeyV4[keyof typeof FormCompletionSectionKeyV4];

const parseCiplNumber = (value: string): number => {
  const normalized = String(value || "")
    .replace(/\./g, "")
    .replace(",", ".");
  return Number(normalized) || 0;
};

// Derived eligibility slice consumed by mapPaymentMethodOptions() — logic-only
// (GENESIS-19584), not persisted on CreateBookingV4.
interface PaymentEligibilityV4 {
  cod: { disabled: boolean; hoverCopy: string };
  dfod: { disabled: boolean; hoverCopy: string };
  // posLimit: { disabled: boolean; remainingLimit: number };
}

// Rebooking carry-over snapshot (GENESIS-19588) — captured from the booking
// entity that was just submitted, before applyCarryOver() resets the rest of
// bookingFormV4. Scope per PRD §3.21: Tab + Pengirim + Barang & Koli + Jenis
// Pengiriman only; everything else resets to default.
interface CarryOverSnapshotV4 {
  activeTab: BookingTabV4Value;
  sender: SenderBookingV4;
  commodity: CommodityBookingV4;
  pieces: PieceBookingV4[];
  commodityCipl: CommodityCiplBookingV4[];
  ciplExchangeRate: { currency: string; rate: number } | null;
  productType: string;
}

// Stable DOM anchor per section — id, not array index, so anchors survive
// conditional render / reorder. Sibling wiring subtasks (GENESIS-20155/6/7)
// tag their mounted section root with these ids; supporting-documents
// (GENESIS-19572) already carries its match.
/* eslint-disable @typescript-eslint/camelcase */
const FORM_COMPLETION_SECTION_ANCHORS: Record<
  FormCompletionSectionKeyV4Value,
  string
> = {
  sender: "booking-v4-section-sender",
  receiver: "booking-v4-section-receiver",
  reference_number: "booking-v4-section-reference-number",
  goods_pieces: "booking-v4-section-goods-pieces",
  product_type: "booking-v4-section-product-type",
  supporting_documents: "booking-v4-section-supporting-documents",
  booking_v4_section_payment_method: "booking-v4-section-payment-method"
};
/* eslint-enable @typescript-eslint/camelcase */

// Mirrors SupportingDocFieldKey from components/supporting-documents-ftz/index.vue
// (GENESIS-19572) minus "dutyTaxTerms", which has no completion-panel row.
// Kept local (not imported from that SFC's <script>) since named type
// exports aren't pulled through the .vue module boundary by this project's
// SFC tooling.
type SupportingDocCompletionFieldKey =
  | "email"
  | "idNumber"
  | "taxNumber"
  | "imageId"
  | "imageTax"
  | "imageBeforePacking"
  | "imageAfterPacking";

// Display order for the Dokumen Pendukung rincian rows — aligned to the
// shipped SupportingDocFieldKey (GENESIS-19572), not a separate naming.
const SUPPORTING_DOC_COMPLETION_FIELD_ORDER: SupportingDocCompletionFieldKey[] = [
  "email",
  "idNumber",
  "taxNumber",
  "imageId",
  "imageTax",
  "imageBeforePacking",
  "imageAfterPacking"
];

const SUPPORTING_DOC_FIELD_LABEL_I18N: Record<
  typeof SUPPORTING_DOC_COMPLETION_FIELD_ORDER[number],
  string
> = {
  email: "bookingV4.formCompletion.email",
  idNumber: "bookingV4.formCompletion.idNumber",
  taxNumber: "bookingV4.formCompletion.taxNumber",
  imageId: "bookingV4.formCompletion.upload.idCard",
  imageTax: "bookingV4.formCompletion.upload.taxCard",
  imageBeforePacking: "bookingV4.formCompletion.upload.packing",
  imageAfterPacking: "bookingV4.formCompletion.upload.packing"
};

const NUMERIC_LOCALE_BY_CURRENCY: Record<string, "id" | "my"> = {
  IDR: "id",
  MYR: "my"
};

@Options({
  name: "CreateBookingManualV4",
  components: {
    BookingSdnBanner,
    HeaderBookingV4,
    SenderSectionV4,
    ReceiverSectionV4,
    ReferenceNumberV4,
    FormCompletionPanel,
    PaymentMethodSelectorV4,
    // SectionVoucherV4,
    // OTPVoucherModalV4,
    GoodsPackageV4,
    ProductCardListV4,
    ProtectionPackingSummary,
    BookingStickyFooterV4,
    TotalTarifSectionV4,
   SupportingDocSectionV4,
    // ModalListVoucher,
    ModalSuccessBookingV4,
    ModalPreviewInvoice,
    ModalFailedBookingV4,
    ModalSuccessReceipt,
    InvoicePdfA4,
    InvoicePdfStruk
  },
  // GENESIS-19591 — deep-watch the derived tariff-estimation context so any
  // field that feeds GetEstimationPriceV4 (origin/destination/weight/product/
  // commodity/insurance/paymentMethod/voucher) re-triggers estimation.
  watch: {
    estimationPriceContextPayload: {
      handler() {
        this.getEstimationPriceDebounced();
        // GENESIS-19592 — voucher list/applied voucher are validated against
        // this same origin/destination/product context; reset on change
        // (mirrors v3's onVoucherContextChanged).
        // this.onVoucherContextChangedDebounced();
      },
      deep: true
    },
    // GENESIS-20157 — PRD §3.7 scopes the prefill re-run trigger to "baris
    // ditambah, dihapus, atau Nama Barang diubah" only — NOT every CIPL
    // field. Watching `commodityCiplPrefillSignature` (row count + id +
    // commodityId + name) instead of a raw `deep: true` array watch keeps
    // Kuantitas/Harga Barang edits from re-firing this and silently
    // clobbering a manual @update:commodity override. A *real* composition
    // change (add/remove/select/Nama Barang) still changes the signature and
    // is allowed to override a prior manual pick (AC "Override manual
    // dilindungi sampai CIPL berubah").
    commodityCiplPrefillSignature() {
      this.commodityUserOverride = false;
      this.applyCommodityPrefillRules();
    },
    exchangeRatePairSignature() {
      this.syncActiveExchangeRate();
    },
    supportingDocContextSignature() {
      this.fetchSupportingDocFieldRules();
    },
    // GENESIS-20471 — re-check live duty-tax (deminimis/dokumen edaran) on
    // any input the resolve payload depends on (destination, chargeable
    // weight, per-commodity aggregated price). Debounced ~250ms per PRD
    // §3.4 so it doesn't spam the endpoint every keystroke.
    dutyTaxResolveContextSignature() {
      this.getDutyTaxResolveDebounced();
    },
    // GENESIS-20160 — re-eval proteksi/woodpacking derive whenever an input
    // it depends on changes (itemPrice, paymentMethod, product type,
    // destination market, pieces GW/VW). Watches a signature string (not the
    // protectionPacking object itself) so this doesn't loop on the very
    // fields onSetInsurance() writes back (protectionChecked/
    // protectionDisabled/woodpackingEligible/woodpackingAdditionalWeightKg).
    protectionDeriveSignature() {
      this.getInsuranceConfig();

      if (this.isCodDfodInsuranceActive) {
        this.onSetInsurance();
      }
    },
    // GENESIS-20159 — re-fetch upselling when origin/destination/commodity/
    // tab changes (same context guard as estimation price + voucher).
    productUpsellingContextSignature: {
      handler() {
        this.fetchProductUpsellingDebounced();
      },
      deep: true
    },

    /*
    async isVoucherContextReady(isReady: boolean) {
      if (!isReady) {
        this.clearVoucherContextState();
      } else if (!this.voucherItems.length && !this.loadingVoucherList) {
        await this.fetchVoucherList();
      }
    },
    */

    // woodpackingEligibilitySignature: {
    //   handler(): void {
    //     this.fetchWoodpackingEligibilityDebounced();
    //   },
    // },
    "bookingFormV4.product.productType"(productNameValue: string) {
      if (productNameValue) {
        this.tempProductName = productNameValue;
      }
    },
    interpackVendorConfigContextSignature() {
      this.fetchInterpackLaneEligibilityDebounced();
    },
    interpackSinglePieceOnly(singlePieceOnly: boolean) {
      if (singlePieceOnly && !this.isMyOrigin) {
        this.trimPiecesForSingleKoliProduct();
      }
    },
    // MY-origin: lane eligibility is fail-closed while resolving (V3 parity),
    // so only trim once the resolve settles as not multi-koli eligible.
    interpackLaneResolving(resolving: boolean) {
      if (!resolving) {
        this.trimPiecesForSingleKoliProduct();
      }
    },
    // GENESIS-20970 — Saved package cards: fetch hanya saat sender terdaftar
    // (sender.id truthy). Sender manual / clear -> sembunyikan section.
    "bookingFormV4.sender.id"(senderId: number) {
      if (senderId) {
        void this.fetchSavedPackages(senderId);
        this.activeSavedPackageId = null;
      } else {
        this.clearSavedPackages();
        this.activeSavedPackageId = null;
      }
    },
    "bookingFormV4.commodity"() {
      if (!this.isPrefillingSavedPackage) {
        this.activeSavedPackageId = null;
      }
    },
    "bookingFormV4.pieces": {
      handler() {
        if (!this.isPrefillingSavedPackage) {
          this.activeSavedPackageId = null;
        }
      },
      deep: true
    },
    currentIndex(newIndex: number) {
      if (newIndex === -1) return;

      if (newIndex >= 9) {
        if (!this.isSenderSectionValid) {
          this.triggerSenderRequiredErrors();
        }
        if (!this.isReceiverSectionValid) {
          this.triggerReceiverRequiredErrors();
        }
      }

      if (newIndex >= 20) {
        if (!this.isGoodsPiecesSectionValid) {
          this.triggerGoodsPackageErrors();
        }
      }
    },
    originCountry() {
      this.getInsuranceAvailability();
    },
    paymentEligibilityChange() {
      this.checkPaymentMethod();
    },
    isSuccessModalVisible() {
      if (!this.isSuccessModalVisible) {
        this.onCheckFraudNumber();
      }
    }
  }
})
class CreateBookingManualV4 extends Vue {
  declare $refs: {
    headerBooking: any;
    goodsPackageRef: any;
    refNumber: any;
    receiverSection: any;
  };

  isSuccessModalVisible = false;
  successBookingData = new SuccessBookingV4();
  bookingFormV4 = this.createBookingFormV4();
  lastExchangeRateContextSignature = "";
  carriedCiplExchangeRate: { currency: string; rate: number } | null = null;
  countryCurrencyByCode: Record<string, string> = {};
  countryCurrencyRequests: Record<string, Promise<void>> = {};
  private createBookingFormV4(isInternational = false): CreateBookingV4 {
    return new CreateBookingV4({
      pageMeta: new PageMetaBookingV4({
        activeTab: isInternational
          ? BookingTabV4.INTERNATIONAL
          : BookingTabV4.DOMESTIC
      }),
      sender: new SenderBookingV4({
        originCity: `${this.districtDetail.name}, ${this.districtDetail.cityName}`,
        originCountryCode: this.accountCountryCode.toUpperCase(),
        phoneCode: !this.isAccountForeignPos ? "+62" : "+60",
        phoneFlag: !this.isAccountForeignPos ? "indonesia" : "malaysia"
      }),
      receiver: new ReceiverBookingV4({
        phoneCode: !this.isAccountForeignPos ? "+62" : "+60",
        phoneFlag: !this.isAccountForeignPos ? "indonesia" : "malaysia"
      }),
      pieces: [this.newPiece(!isInternational)],
      commodityCipl: isInternational
        ? [
            new CommodityCiplBookingV4({
              id: 1,
              quantity: "0",
              goodsPrice: "0"
            })
          ]
        : []
    });
  }

  errors = new ErrorBookingV4();

  formCompletionSectionKeyV4 = FormCompletionSectionKeyV4;

  // --- Tariff estimation wiring (GENESIS-19591) — consumed by the
  // TotalTarifSectionV4 :isLoading/:isError props once GENESIS-20108 (Hold)
  // and GENESIS-20161 (Todo, StickyFooter wrapper mount) ship; owned here per
  // the detailing's parent-bind contract regardless of the child's status.
  estimationLoading = false;
  estimationIsError = false;
  estimationRequestId = 0;

  // --- Rebooking carry-over engine (GENESIS-19588) ---
  // Mirrors v3's isRebookingFlow/carryOverProductName naming — inline state,
  // no separate *Engine class (per detailing scoping note).
  isRebookingFlow = false;
  hasPickedProductNameManually = false;
  carryOverProductName: string | null = null;

  // --- Jenis Pengiriman / ProductCardListV4 wiring (GENESIS-20159) ---
  productUpsellingData: PosterProduct[] = [];
  productUpsellingLoading = false;
  productUpsellingIsError = false;
  errorRouteNotFound = false;
  agentDiscountRevealed = true;
  fetchPromisesAfterGetUpselling: string[] = [];

  get isBookingRetail(): boolean {
    return this.accountType !== "client";
  }

  get isSuperAdminBooking(): boolean {
    return AccountController.accountData.role_type === "POS Super Admin";
  }

  get partnerIsAllowBookVippack(): boolean {
    return (
      AccountController.accountData.account_type_detail
        ?.partnerIsAllowBookVippack ?? false
    );
  }

  get productCardItems(): ProductCardItem[] {
    const { list, upselling } = this.reorderProductTypes;
    // Map to ProductCardItem[]
    const hasRecommended = upselling.some((p) => p.isRecommended);

    return list
      .map((type) => {
        const poster = upselling.find(
          (item) => item.productType.toUpperCase() === type.toUpperCase()
        );
        if (!poster)
          return new PosterProduct({
            productType: type,
            isRecommended: !hasRecommended && type.toUpperCase() === "BOSSPACK"
          });

        const isRecommended = !hasRecommended
          ? poster.productType.toUpperCase() === "BOSSPACK"
          : Boolean(poster.isRecommended) && this.isBookingRetail;

        // Parse SLA string (e.g. "1-3 Hari" -> min=1, max=3)
        const slaParts = (poster.estimateSla || "")
          .replace(/\s*Hari\s*/i, "")
          .split("-")
          .map((s) => parseInt(s.trim(), 10));
        const slaMinDays = Number.isFinite(slaParts[0]) ? slaParts[0] : 0;
        const slaMaxDays = Number.isFinite(slaParts[1])
          ? slaParts[1]
          : slaMinDays;

        return {
          productType: poster.productType.toUpperCase(),
          isAvailable: poster.totalTariff != null && poster.totalTariff > 0,
          isEmbargo: poster.isEmbargo ?? false,
          isRecommended,
          shippingCost: poster.totalTariff ?? null,
          slaMinDays,
          slaMaxDays,
          commissionRate: poster.commissionRate ?? 0,
          commissionAmount: poster.bookingCommission ?? 0
        } as ProductCardItem;
      })
      .filter((item): item is ProductCardItem => item !== null);
  }

  get listProducts(): string[] {
    const products: string[] =
      this.formAccountNumericLocale === "my"
        ? FlagsPermissionBookingV3.config_upselling_product_list.getValue()
            .countries.MY.retail
        : FlagsPermissionBookingV3.config_upselling_product_list.getValue()
            .retail;
    return products;
  }

  get reorderProductTypes() {
    const listProduct = this.listProducts;
    let upselling = this.productUpsellingData;

    // Filter by active tab (Domestik vs Internasional).
    // Daftar produk per tab dikonfigurasi via Unleash BCS
    // config_product_by_type_retail, dikunci per negara (ID/MY).
    const isInternationalTab = this.activeTab === BookingTabV4.INTERNATIONAL;
    const productByType = FlagsPermissionBookingV4.config_product_by_type_retail.getValue();
    const countryConfig =
      productByType[this.formAccountNumericLocale.toUpperCase()] ??
      productByType.ID ??
      {};
    const domesticTypes = new Set<string>(countryConfig.domestic ?? []);
    const internationalTypes = new Set<string>(countryConfig.international ?? []);

    upselling = upselling.filter((item) => {
      const type = item.productType.toUpperCase();
      if (isInternationalTab) return internationalTypes.has(type);
      return domesticTypes.has(type);
    });

    const filteredListProduct = listProduct.filter((p) => {
      if (isInternationalTab) {
        return internationalTypes.has(p);
      }

      return domesticTypes.has(p);
    });

    // Apply recommendation order (recommended-first, cheapest among recommended)
    const orderedTypes = applyRecommendationOrder(
      filteredListProduct,
      upselling
    );

    return {
      list: orderedTypes,
      upselling
    };
  }

  onProductTypeSelect(productType: string): void {
    this.bookingFormV4.product.productType = productType;
    if (!this.isMyOrigin) {
      this.trimPiecesForSingleKoliProduct();
    }
    this.hasPickedProductNameManually = true;
  }

  get isMyOrigin(): boolean {
    return this.accountCountryCode.toUpperCase() === "MY";
  }

  get interpackLaneResolving(): boolean {
    return ProductController.interpackLaneResolving;
  }

  get isSingleKoliProduct(): boolean {
    return ["INTERPACK", "INTERPACKMAXI"].includes(
      this.bookingFormV4.product.productType.toUpperCase()
    );
  }

  trimPiecesForSingleKoliProduct(): void {
    if (!this.interpackSinglePieceOnly || this.bookingFormV4.pieces.length <= 1)
      return;
    this.bookingFormV4.pieces = this.bookingFormV4.pieces.slice(0, 1);
  }

  // --- Multi-koli INTERPACK lane eligibility (GENESIS-20516) ---
  // isSingleKoliProduct stays a pure product check (used elsewhere); this
  // getter layers the MY-origin lane-eligibility resolve on top, fail-closed
  // (single koli) until the resolve call confirms multi-koli is supported.
  get interpackSinglePieceOnly(): boolean {
    if (this.interpackLaneResolving) return false;
    if (!this.isSingleKoliProduct) return false;
    if (!this.isMyOrigin) return true;
    return !ProductController.interpackLaneMultiplePieces;
  }

  get interpackVendorConfigContextSignature(): string {
    return JSON.stringify({
      isSingleKoliProduct: this.isSingleKoliProduct,
      originCountryCode: this.accountCountryCode,
      destinationCountryCode: this.destinationCityDetail?.countryCode || "",
      commodityCode: this.bookingFormV4.commodity.code || ""
    });
  }

  fetchInterpackLaneEligibilityDebounced = debounce(() => {
    const destinationCountryCode = this.destinationCityDetail?.countryCode || "";
    const commodityCode = this.bookingFormV4.commodity.code;
    if (
      !this.isSingleKoliProduct ||
      this.accountCountryCode.toUpperCase() !== "MY" ||
      !destinationCountryCode ||
      !commodityCode
    ) {
      return;
    }
    ProductController.fetchInterpackLaneMultiplePieces({
      originCountryCode: this.accountCountryCode,
      destinationCountryCode,
      commodityCode
    });
  }, 500).bind(this);

  onAgentDiscountRevealedUpdate(value: boolean): void {
    this.agentDiscountRevealed = value;
  }

  async onProductUpsellingRetry(): Promise<void> {
    await this.fetchProductUpselling();
  }

  async fetchProductUpselling(): Promise<void> {
    const destination = this.destinationCityDetail;
    if (!destination?.id) return;

    this.productUpsellingLoading = true;
    this.productUpsellingIsError = false;
    this.errorRouteNotFound = false;

    try {
      const resp = await BookingV4Controller.postToGetPosterProduct(
        this.upsellingPayload
      );
      this.productUpsellingData = resp.map(
        (product: any) =>
          new PosterProduct({
            productType: product.name,
            estimateSla: product.sla,
            totalTariffAfterDiscount: product.total_tariff_after_discount,
            commissionRate: product.commission_rate,
            bookingCommission: product.booking_commission,
            isEmbargo: product.is_embargo,
            shippingCost: product.shipping_cost,
            isRecommended: Boolean(product.is_recommended),
            publishRate: product.publish_rate ?? 0,
            shippingSurchargeRate: product.shipping_surcharge_rate ?? 0,
            forwardRates: product.forward_rates ?? 0,
            totalTariff: product.total_tariff ?? 0
          })
      );
      if (!resp.length) return;
      const { list } = this.reorderProductTypes;
      if (!list.length) return;
      const hasRecommended = resp.some((p) => p.isRecommended);
      const availableTypes = resp
        .filter((p) => list.includes(p.name.toUpperCase()))
        .filter((p) => !p.isEmbargo)
        .map((p: any) => p.name);
      const sortedAvailableTypes = [...availableTypes].sort(
        (a, b) => list.indexOf(a.toUpperCase()) - list.indexOf(b.toUpperCase())
      );
      this.bookingFormV4.product.productType = resolveSelection(
        list,
        this.bookingFormV4.product.productType,
        this.hasPickedProductNameManually,
        this.carryOverProductName,
        hasRecommended,
        sortedAvailableTypes
      );
      this.fetchPromisesAfterGetUpselling.forEach((fn: any) => {
        this[fn as keyof CreateBookingManualV4]();
      });
      this.fetchPromisesAfterGetUpselling = [];
    } catch (err) {
      this.handleErrorUpselling(err);
    } finally {
      this.productUpsellingLoading = false;
    }
  }

  handleErrorUpselling(err: any): void {
    this.productUpsellingData = [];
    this.productUpsellingIsError = err?.response?.status >= 500;
    this.hasPickedProductNameManually = false;
    this.errorRouteNotFound =
      !this.productUpsellingIsError &&
      err?.response?.data?.message?.id ===
        "Harga Shipping Surcharge dan Publish Rate untuk rute yang dipilih tidak tersedia";
    this.bookingFormV4.product.productType = "";
  }

  clearSessionStorage() {
    sessionStorage.removeItem(PRINT_RECEIPT_KEY.LIST_STT_SUCCESS_BOOKING);
    sessionStorage.removeItem(PRINT_RECEIPT_KEY.LAST_DATE_STT_SUCCESS_BOOKING);

    PrintReceiptController.SET_LIST_STT_SUCCESS_BOOKING([]);
    PrintReceiptController.SET_LAST_DATE_STT_SUCCESS_BOOKING("");
  }

  mounted() {
    // Reuse existing action (no new endpoint) — status Limit Tagihan is POS-only.
    // if (this.isPosAccount) {
    // }
    // GENESIS-20157 — country-aware volumetric divisor (V3 parity) + initial
    // commodity list state (CIPL dropdown, recommendations, Lihat Semua
    // category sidebar).
    this.getHWSConfig();
    this.getRoundingRulesConfig();
    this.getCODConfig();
    this.getInsuranceAvailability();
    // InvoiceLimitController.getInvoiceLimitStatusSummary();
    ProductController.fetchVolumetricDivisors(this.accountCountryCode);
    this.fetchCiplCommodityOptions();
    this.refreshCommodityRecommendations();
    this.fetchCommodityCategories();
    this.syncActiveExchangeRate();
    this.fetchSupportingDocFieldRules();
    // GENESIS-20160 — set initial proteksi/woodpacking derive state. First
    // derive pass seeds Business Rules default (protectionChecked=true/basic)
    // via previousProtectionDisabled once insurance is available & enabled;
    // threshold/woodpacking eligibility depend on state not known at
    // construction time.
    this.onSetInsurance();
    window.addEventListener("keydown", this.onEnterSubmit);
  }

  unmounted() {
    window.removeEventListener("keydown", this.onEnterSubmit);
    this.clearSessionStorage();
  }

  // --- Header bind (GENESIS-19568) ---
  onActiveTabUpdate(value: BookingTabV4Value) {
    this.resetFormByTab(value);
  }

  resetFormByTab(value: BookingTabV4Value): void {
    const isInternational = value === BookingTabV4.INTERNATIONAL;

    Object.assign(
      this.bookingFormV4,
      this.createBookingFormV4(isInternational)
    );

    if (!this.showItemDetails) {
      this.onCiplValidationChange(true);
    }

    this.$nextTick(() => {
      const goodsPackage = this.$refs.goodsPackageRef as any;
      if (
        goodsPackage &&
        typeof goodsPackage.resetItemDetailsTouchedFields === "function"
      ) {
        goodsPackage.resetItemDetailsTouchedFields();
      }
      this.errors = new ErrorBookingV4();
    });

    this.errors = new ErrorBookingV4();

    // reset index sender/receiver
    this.senderCountryIndex = 1;
    this.senderNameIndex = 2;
    this.senderPhoneIndex = 3;
    this.senderAddressIndex = 4;
    this.receiverCountryIndex = 5;
    this.receiverNameIndex = 6;
    this.receiverPhoneIndex = 7;
    this.receiverAddressIndex = 8;
    this.receiverDistrictIndex = isInternational ? 10 : 9;
    this.receiverPostalCodeIndex = isInternational ? 9 : 10;

    // reset validation state
    this.isSenderSectionValid = false;
    this.isReceiverSectionValid = false;
    this.isReferenceSectionValid = false;
    this.isCommoditySectionValid = false;
    this.isPackageWeightSectionValid = false;
    this.isCiplSectionValid = false;
    this.isSupportingDocSectionValid = false;

    // reset supporting document state
    this.supportingDocFieldRules = {};
    this.supportingDocFieldRulesReady = false;
    this.supportingDocRulesRequestId++;

    // reset submit state
    this.hasAttemptedSubmit = false;
    // this.isLimitTagihanInsufficient = false;

    // reset commodity state
    this.commodityUserOverride = false;
    this.commoditySearchResults = [];
    this.commodityListPage = 1;
    this.commodityListTotalData = 0;

    // reset commodity modal
    this.modalSearchResults = [];
    this.commodityModalPage = 1;
    this.commodityModalTotalData = 0;
    this.selectedCategoryCode = null;
    this.commodityCategoryItems = [];

    // reset product upselling
    this.productUpsellingData = [];
    this.productUpsellingLoading = false;
    this.productUpsellingIsError = false;
    this.errorRouteNotFound = false;
    this.agentDiscountRevealed = false;

    // Voucher reset temporarily disabled on MY retail branch.
    // this.voucherItems = [];
    // this.voucherPagination = new BookingVoucherPagination();
    // this.voucherTermsVoucher = new BookingVoucherItem();
    // this.voucherManualCode = "";
    // this.voucherManualError = "";
    // this.appliedVoucherItem = new BookingVoucherItem();
    // this.resetOtpVoucherState();

    // reset carry-over state
    this.isRebookingFlow = false;
    this.carryOverProductName = null;

    // reset current section focus
    this.currentIndex = -1;

    // reset exchange rate
    BookingV4Controller.clearActiveExchangeRate();

    // re-run context dependent initialization
    this.isItemDetailsRequired = true;
    this.fetchSupportingDocFieldRules();
    this.onSetInsurance();
  }

  onReceiptFormatUpdate(value: ReceiptFormatV4Value) {
    this.bookingFormV4.pageMeta.receiptFormat = value;
  }

  // --- Pengirim/Penerima wiring (GENESIS-20155) — sequential tab-order
  // constants mirroring create-booking-v3/create-booking-manual.vue's inline
  // indices (sender 1-4, receiver 5-10); shared currentIndex drives focus
  // ordering across both sections (mirror v3's single `currentIndex`).
  senderCountryIndex = 1;
  senderNameIndex = 2;
  senderPhoneIndex = 3;
  senderAddressIndex = 4;
  receiverCountryIndex = 5;
  receiverNameIndex = 6;
  receiverPhoneIndex = 7;
  receiverAddressIndex = 8;
  receiverDistrictIndex = 9;
  receiverPostalCodeIndex = 10;

  currentIndex = -1;

  // SenderSectionV4/ReceiverSectionV4 mutate `modelValue` (the full
  // CreateBookingV4 object, passed by reference) in place then re-emit it —
  // reassigning here keeps bookingFormV4 the single source of truth per the
  // detailing's parent-wiring contract (child never calls BookingV4Controller).
  onSenderUpdate(value: CreateBookingV4): void {
    this.bookingFormV4 = value;
  }

  onSelectPhoneNumber(senderId: number): void {
    if (senderId) {
      void this.fetchSavedPackages(senderId);
      this.activeSavedPackageId = null;
    } else {
      this.clearSavedPackages();
      this.activeSavedPackageId = null;
    }
  }

  onReceiverUpdate(value: CreateBookingV4): void {
    this.bookingFormV4 = value;
    void this.syncActiveExchangeRate();
  }

  onSenderValidationChange(valid: boolean): void {
    this.isSenderSectionValid = valid;
  }

  onReceiverValidationChange(valid: boolean): void {
    this.isReceiverSectionValid = valid;
  }

  onSupportingDocUpdate(value: SupportingDocBookingV4): void {
    this.bookingFormV4.supportingDoc = value;
  }

  onSupportingDocValidationChange(valid: boolean): void {
    this.isSupportingDocSectionValid =
      this.supportingDocFieldRulesReady && valid;
  }

  // --- Nomor Referensi wiring (GENESIS-20156) ---
  onReferencesUpdate(value: ReferenceChipV4[]): void {
    this.bookingFormV4.references = value;
  }

  onReferenceValidationChange(valid: boolean): void {
    this.isReferenceSectionValid = valid;
  }

  onSectionCurrentIndexUpdate(index: number): void {
    this.currentIndex = index;
  }

  get isErrorEmbargoDestination() {
    return (
      this.productUpsellingData.length > 0 &&
      this.productUpsellingData.every((item) => item.isEmbargo) &&
      !!this.bookingFormV4.receiver.destinationCity
    );
  }

  // --- Barang & Koli wiring (GENESIS-20157) ---
  readonly maxGoodsPieces = 15; // PRD §3.8.5

  // GENESIS-20471 — live duty-tax infobar is only in scope for the
  // international tab (isFtz/domestic never sends CIPL data to resolve).
  get ENABLE_DUTY_TAX_INFOBAR(): boolean {
    return this.isCipl;
  }

  commodityUserOverride = false;

  // Live resolve() result driving ciplDeminimisThreshold/
  // recipientImportDocRequired/ciplDeminimisExceeded below — null means "no
  // match / not yet resolved / resolve failed", which never blocks submit.
  dutyTaxResolveResult: DutyTaxResolveResult | null = null;

  // Nama Barang dropdown (CIPL, §3.6.2) options — a dedicated, eagerly-fetched
  // list, deliberately NOT shared with commoditySearchResults below (that one
  // is the main Komoditas searchbar's transient, keystroke-driven search
  // state and would leave the CIPL dropdown empty/stale otherwise).
  ciplCommodityOptions: CommodityBookingV4[] = [];

  commoditySearchResults: CommodityBookingV4[] = [];
  commodityRecommendations: CommodityBookingV4[] = [];
  commodityListLoading = false;
  commodityListPage = 1;
  commodityListTotalData = 0;

  savedPackages: SavedPackageBookingV4[] = [];
  savedPackagesLoading = false;
  savedPackageRequestId = 0;
  savePackage = false;
  activeSavedPackageId: number | null = null;
  isPrefillingSavedPackage = false;

  modalSearchResults: CommodityBookingV4[] = [];
  commodityModalLoading = false;
  commodityModalPage = 1;
  commodityModalTotalData = 0;

  commodityCategories: CommodityCategoryV4[] = [];
  commodityCategoryItems: CommodityBookingV4[] = [];
  selectedCategoryCode: string | null = null;
  commodityModalLoadingCategory = false;
  isItemDetailsRequired = true;

  // Sender emits @autofillCommodity (GENESIS-19570 -> GENESIS-20155 forward)
  // when the user picks a saved customer whose commodity autofills. Distinct
  // from applyCommodityPrefillRules(): the source is customer data, not CIPL,
  // so §3.7's prefill rules never run here (per detailing's explicit note).
  async onAutofillCommodity(): Promise<void> {
    await this.refreshCommodityRecommendations();
    this.validateCommodityActive(this.bookingFormV4.commodity);
    this.commodityUserOverride = false;
  }

  mapCommodityListToBookingV4(list: Commodity[]): CommodityBookingV4[] {
    return list.map(
      (item) =>
        new CommodityBookingV4({
          id: item.commodity_id,
          name: item.commodity_name,
          nameEn: item.commodity_name_en,
          code: item.commodity_code,
          isDangerousGoods: item.isDangerousGoods,
          isQuarantine: item.isQuarantine,
          status: item.commodity_status
        })
    );
  }

  validateCommodityActive(commodity: CommodityBookingV4): void {
    const isInactive =
      !!commodity.id && !!commodity.status && commodity.status !== "active";
    this.errors.commodity = isInactive
      ? (this.$t("bookingV4.goods.commodity.errorInactive") as string)
      : "";
  }

  closeModalFailed(): void {
    this.isShowModalFailedBooking = false;
  }
  /*
  closeModalListVoucher(): void {
    this.isSeeMoreExpanded = false;
  }

  async onSelectVoucherFromModal(voucher: BookingVoucherItem): Promise<void> {
    if (!voucher.isEligible) return;

    this.voucherManualCode = voucher.voucherCode;
    await this.submitVoucherManualCode();

    if (!this.voucherManualError) {
      this.closeModalListVoucher();
    }
  }

  async submitVoucherManualCodeFromModal(): Promise<void> {
    await this.submitVoucherManualCode();
    if (
      this.bookingFormV4.voucher.appliedVoucherCode &&
      !this.voucherManualError
    ) {
      this.closeModalListVoucher();
    }
  }
  */

  async fetchCiplCommodityOptions(): Promise<void> {
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          limit: 100,
          commodityStatus: "active",
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.ciplCommodityOptions = this.mapCommodityListToBookingV4(resp.data);
    } catch (error) {
      this.ciplCommodityOptions = [];
    }
  }

  async setDuplicateCommodityCipl() {
    await this.fetchCiplCommodityOptions();
    if (!this.bookingFormV4.commodityCipl.length) return;
    const matches = await this.fetchMissingCiplCommodities();
    const knownIds = new Set(
      this.ciplCommodityOptions.map((commodity) => commodity.id)
    );
    this.ciplCommodityOptions.push(
      ...matches.filter((commodity) => {
        if (knownIds.has(commodity.id)) return false;
        knownIds.add(commodity.id);
        return true;
      })
    );
    this.hydrateCiplCommodityMetadata();
  }

  // Cari metadata baris Adjust yang tidak tersedia pada initial commodity list.
  async fetchMissingCiplCommodities(): Promise<CommodityBookingV4[]> {
    const searches = Array.from(
      new Set(
        this.bookingFormV4.commodityCipl
          .filter(
            (row) =>
              !this.findCiplCommodity(row) && Boolean(row.name.trim())
          )
          .map((row) => row.name.trim())
      )
    );
    const results = await Promise.all(
      searches.map((search) => this.fetchCiplCommodityMatch(search))
    );
    return results.reduce<CommodityBookingV4[]>(
      (commodities, result) => [...commodities, ...result],
      []
    );
  }

  async fetchCiplCommodityMatch(
    search: string
  ): Promise<CommodityBookingV4[]> {
    try {
      const response = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          search,
          limit: 20,
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      return this.mapCommodityListToBookingV4(response.data);
    } catch {
      return [];
    }
  }

  hydrateCiplCommodityMetadata(): void {
    // GENESIS-23382 — Fixing ini mungkin impact ke Adjust STT Interpack,
    // Retail, Client, dan Internal. Minta tolong cek badge DG/K dan prefill.
    this.bookingFormV4.commodityCipl = this.bookingFormV4.commodityCipl.map(
      (row) => {
        const commodity = this.findCiplCommodity(row);
        if (!commodity) return row;

        return new CommodityCiplBookingV4({
          ...row,
          commodityId: commodity.id,
          code: commodity.code,
          hsCode: row.hsCode || commodity.hsCode,
          isDangerousGoods: commodity.isDangerousGoods,
          isQuarantine: commodity.isQuarantine,
          status: commodity.status
        });
      }
    );
    this.applyCommodityPrefillRules();
  }

  findCiplCommodity(row: CommodityCiplBookingV4): CommodityBookingV4 | null {
    const normalizedValues = [row.name, row.code]
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);

    return (
      this.ciplCommodityOptions.find(
        (commodity) =>
          (row.commodityId > 0 && commodity.id === row.commodityId) ||
          [commodity.code, commodity.name, commodity.nameEn]
            .map((value) => value.trim().toLowerCase())
            .some((value) => normalizedValues.includes(value))
      ) || null
    );
  }

  async refreshCommodityRecommendations(): Promise<void> {
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          isRecommendedOnly: true,
          limit: 6,
          commodityStatus: "active",
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.commodityRecommendations = this.mapCommodityListToBookingV4(
        resp.data
      ).slice(0, 6);
    } catch (error) {
      this.commodityRecommendations = [];
    }
  }

  async fetchSavedPackages(customerId: number): Promise<void> {
    const requestId = ++this.savedPackageRequestId;
    this.savedPackagesLoading = true;
    try {
      const packages = await BookingV4Controller.getSavedPackage(customerId);
      if (requestId !== this.savedPackageRequestId) return;
      const resolved = await this.resolveSavedPackageCommodities(
        packages.slice(0, 3)
      );
      if (requestId !== this.savedPackageRequestId) return;
      this.savedPackages = resolved;
    } catch (error) {
      console.error("fetchSavedPackages failed", error);
      if (requestId === this.savedPackageRequestId) this.savedPackages = [];
    } finally {
      if (requestId === this.savedPackageRequestId) {
        this.savedPackagesLoading = false;
      }
    }
  }

  async resolveSavedPackageCommodities(
    packages: SavedPackageBookingV4[]
  ): Promise<SavedPackageBookingV4[]> {
    return Promise.all(
      packages.map(async (pkg) => {
        if (!pkg.commodityCode) return pkg;
        const commodity = await CommodityController.getDetailCommodityByCode(
          pkg.commodityCode
        );
        return new SavedPackageBookingV4({
          ...pkg,
          commodityId: commodity.commodity_id,
          commodityStatus: commodity.commodity_status,
          commodityName: commodity.commodity_name,
          commodityNameEn: commodity.commodity_name_en,
          isDangerousGoods: commodity.isDangerousGoods,
          isQuarantine: commodity.isQuarantine
        });
      })
    );
  }

  clearSavedPackages(): void {
    this.savedPackageRequestId += 1;
    this.savedPackages = [];
    this.savedPackagesLoading = false;
  }

  async fetchCommodityCategories(): Promise<void> {
    try {
      const categories = await CommodityController.getCommodityCategory(
        this.accountCountryCode.toUpperCase()
      );
      this.commodityCategories = categories.map(
        (item) =>
          ({
            code: item.commodityCategoryCode,
            name: item.commodityCategoryNameId,
            nameEn: item.commodityCategoryNameEn
          } as CommodityCategoryV4)
      );
    } catch (error) {
      this.commodityCategories = [];
    }
  }
  /*
  get sortedVouchers() {
    const eligible = [...this.voucherItems]
      .filter((voucher) => voucher.isEligible)
      .sort((a, b) => (b.estimatedSaving || 0) - (a.estimatedSaving || 0));
    const disabled = this.voucherItems.filter((voucher) => !voucher.isEligible);

    return [...eligible, ...disabled];
  }
  */

  get commodityListHasMore(): boolean {
    return this.commodityListPage * 20 < this.commodityListTotalData;
  }

  async searchCommodity(keyword: string): Promise<void> {
    this.commodityListLoading = true;
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          search: keyword,
          page: 1,
          limit: 20,
          commodityStatus: "active",
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.commoditySearchResults = this.mapCommodityListToBookingV4(resp.data);
      this.commodityListPage = 1;
      this.commodityListTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      this.commoditySearchResults = [];
      this.commodityListTotalData = 0;
    } finally {
      this.commodityListLoading = false;
    }
  }

  async loadMoreCommodities(keyword: string): Promise<void> {
    if (!this.commodityListHasMore || this.commodityListLoading) return;
    this.commodityListLoading = true;
    try {
      const nextPage = this.commodityListPage + 1;
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          commodityStatus: "active",
          search: keyword,
          page: nextPage,
          limit: 20,
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.commoditySearchResults = [
        ...this.commoditySearchResults,
        ...this.mapCommodityListToBookingV4(resp.data)
      ];
      this.commodityListPage = nextPage;
      this.commodityListTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      // Keep the already-loaded page(s); just stop paginating on failure.
    } finally {
      this.commodityListLoading = false;
    }
  }

  get commodityModalHasMore(): boolean {
    return this.commodityModalPage * 20 < this.commodityModalTotalData;
  }

  async searchCommodityModal(keyword: string): Promise<void> {
    this.commodityModalLoading = true;
    this.selectedCategoryCode = null;
    this.commodityCategoryItems = [];
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          search: keyword,
          page: 1,
          limit: 20,
          commodityStatus: "active",
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.modalSearchResults = this.mapCommodityListToBookingV4(resp.data);
      this.commodityModalPage = 1;
      this.commodityModalTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      this.modalSearchResults = [];
      this.commodityModalTotalData = 0;
    } finally {
      this.commodityModalLoading = false;
    }
  }

  async loadMoreCommodityModal(keyword: string): Promise<void> {
    if (!this.commodityModalHasMore || this.commodityModalLoading) return;
    this.commodityModalLoading = true;
    try {
      const nextPage = this.commodityModalPage + 1;
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          commodityStatus: "active",
          search: keyword,
          page: nextPage,
          limit: 20,
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.modalSearchResults = [
        ...this.modalSearchResults,
        ...this.mapCommodityListToBookingV4(resp.data)
      ];
      this.commodityModalPage = nextPage;
      this.commodityModalTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      // Keep the already-loaded page(s); just stop paginating on failure.
    } finally {
      this.commodityModalLoading = false;
    }
  }

  async selectCommodityCategory(code: string): Promise<void> {
    this.selectedCategoryCode = code;
    this.commodityModalLoadingCategory = true;
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          commodityStatus: "active",
          commodityCategoryCode: code,
          page: 1,
          limit: 100,
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.commodityCategoryItems = this.mapCommodityListToBookingV4(resp.data);
    } catch (error) {
      this.commodityCategoryItems = [];
    } finally {
      this.commodityModalLoadingCategory = false;
    }
  }

  onCommodityCiplUpdate(value: CommodityCiplBookingV4[]): void {
    this.bookingFormV4.commodityCipl = value;
  }

  onCommodityError(errorMessage: string) {
    this.errors.commodity = errorMessage;
  }

  // Fingerprint of exactly the fields PRD §3.7's trigger rule cares about
  // (row identity + which commodity it resolves to + free-text name) — NOT
  // quantity/goodsPrice. Watched instead of a raw `deep: true` array watch
  // so unrelated field edits can't re-fire the prefill re-run.
  get commodityCiplPrefillSignature(): string {
    return this.bookingFormV4.commodityCipl
      .map((row) => `${row.id}:${row.commodityId}:${row.name}`)
      .join("|");
  }

  // §3.7 Business Rules — resolves each CIPL row to its source commodity
  // (rows still in free text, i.e. commodityId <= 0, are excluded) then picks
  // per the 7-condition table: DG always outranks non-DG; within a group the
  // majority wins; ties go to whichever appears first (topmost row). A
  // single resolved row is just a trivial one-item "majority", so it needs
  // no special-cased branch.
  applyCommodityPrefillRules(): void {
    const resolved = this.bookingFormV4.commodityCipl
      .map((row) => this.resolveCiplRowCommodity(row))
      .filter((item): item is CommodityBookingV4 => item !== null);

    if (!resolved.length) return; // condition 7 — all free text, no prefill

    const dgGroup = resolved.filter((item) => item.isDangerousGoods);
    const nonDgGroup = resolved.filter((item) => !item.isDangerousGoods);
    const winner = this.pickMajorityCommodity(
      dgGroup.length ? dgGroup : nonDgGroup
    );
    if (winner) this.setPrefillCommodity(winner);
  }

  // CIPL "Nama Barang" dropdown options are its own eagerly-fetched list
  // (ciplCommodityOptions), NOT the main Komoditas searchbar's transient
  // search-results state — the latter starts empty and is replaced wholesale
  // per keystroke, which would make CIPL row -> commodity resolution (and
  // therefore prefill) depend on what the user last typed in a different
  // field entirely.
  resolveCiplRowCommodity(
    row: CommodityCiplBookingV4
  ): CommodityBookingV4 | null {
    if (!row.commodityId || row.commodityId <= 0) return null;
    const commodity = this.ciplCommodityOptions.find(
      (item) => item.id === row.commodityId
    );
    if (commodity) return commodity;

    return new CommodityBookingV4({
      id: row.commodityId,
      name: row.name,
      code: row.code,
      hsCode: row.hsCode,
      status: row.status,
      isDangerousGoods: row.isDangerousGoods,
      isQuarantine: row.isQuarantine
    });
  }

  pickMajorityCommodity(
    group: CommodityBookingV4[]
  ): CommodityBookingV4 | null {
    if (!group.length) return null;
    const countByCode = new Map<string, number>();
    const firstIndexByCode = new Map<string, number>();
    group.forEach((item, index) => {
      countByCode.set(item.code, (countByCode.get(item.code) || 0) + 1);
      if (!firstIndexByCode.has(item.code)) {
        firstIndexByCode.set(item.code, index);
      }
    });

    let bestCode = "";
    let bestCount = -1;
    let bestFirstIndex = Infinity;
    countByCode.forEach((count, code) => {
      const firstIndex = firstIndexByCode.get(code) ?? Infinity;
      if (
        count > bestCount ||
        (count === bestCount && firstIndex < bestFirstIndex)
      ) {
        bestCode = code;
        bestCount = count;
        bestFirstIndex = firstIndex;
      }
    });

    return group.find((item) => item.code === bestCode) || null;
  }

  setPrefillCommodity(commodity: CommodityBookingV4): void {
    this.bookingFormV4.commodity = new CommodityBookingV4(commodity);
    this.validateCommodityActive(this.bookingFormV4.commodity);
    this.commodityUserOverride = false;
  }

  onCommodityUpdate(value: CommodityBookingV4 | null): void {
    this.bookingFormV4.commodity = value || new CommodityBookingV4();
    this.commodityUserOverride = true;
  }

  onPiecesUpdate(value: PieceBookingV4[]): void {
    this.bookingFormV4.pieces = value;
  }

  // GENESIS-20531 — Prefill package fields saat tap body card paket tersimpan.
  async onSavedPackageSelect(pkg: SavedPackageBookingV4): Promise<void> {
    const target =
      pkg instanceof SavedPackageBookingV4
        ? pkg
        : new SavedPackageBookingV4(pkg);

    if (!target.pieces?.length && target.id) {
      try {
        const detail = await BookingV4Controller.getSavedPackageDetail({
          customerId: this.bookingFormV4.sender.id,
          packageId: target.id
        });
        if (detail?.pieces?.length) {
          target.pieces = detail.pieces;
        }
      } catch {
        // fallback: prefill tanpa pieces
      }
    }

    this.isPrefillingSavedPackage = true;
    this.applySavedPackagePrefill(target);
    this.activeSavedPackageId = target.id || null;
    this.$nextTick(() => {
      this.isPrefillingSavedPackage = false;
    });
  }

  applySavedPackagePrefill(pkg: SavedPackageBookingV4): void {
    const commodity = new CommodityBookingV4({
      id: pkg.commodityId,
      code: pkg.commodityCode,
      name: pkg.commodityName,
      nameEn: pkg.commodityNameEn,
      isDangerousGoods: pkg.isDangerousGoods,
      isQuarantine: pkg.isQuarantine,
      status: pkg.commodityStatus
    });

    const existsInSearchResults = this.commoditySearchResults.some(
      (item) => item.code === commodity.code || item.id === commodity.id
    );
    if (!existsInSearchResults && commodity.code) {
      this.commoditySearchResults = [commodity, ...this.commoditySearchResults];
    }

    const pieces = pkg.pieces.map(
      (piece) =>
        new PieceBookingV4({
          length: piece.length,
          width: piece.width,
          height: piece.height,
          grossWeight: piece.grossWeight,
          volumeWeight: this.computeVolumeWeight(
            piece.length,
            piece.width,
            piece.height
          ),
          error: new ErrorPiecesBookingV4()
        })
    );

    this.errors.commodity = "";
    this.errors.pieces = "";
    this.onCommodityUpdate(commodity);
    if (pieces.length > 0) {
      this.onPiecesUpdate(pieces);
    }
  }

  onSavePackageUpdate(val: boolean): void {
    this.savePackage = val;
  }

  newPiece(useDefaultDimensions = true): PieceBookingV4 {
    const length = useDefaultDimensions ? 3 : 0;
    const width = useDefaultDimensions ? 20 : 0;
    const height = useDefaultDimensions ? 10 : 0;
    return new PieceBookingV4({
      length,
      width,
      height,
      grossWeight: 0,
      volumeWeight: this.computeVolumeWeight(length, width, height),
      error: new ErrorPiecesBookingV4()
    });
  }

  computeVolumeWeight(length: number, width: number, height: number): number {
    if (!this.volumeWeightDivisorForSelectedProduct) return 0;
    return (
      (length * width * height) / this.volumeWeightDivisorForSelectedProduct
    );
  }

  onGoodsPackageReset(): void {
    this.bookingFormV4.commodityCipl = [];
    this.bookingFormV4.commodity = new CommodityBookingV4();
    this.bookingFormV4.pieces = [this.newPiece(!this.isCipl)];
    this.bookingFormV4.commodityCipl = this.showItemDetails
      ? [new CommodityCiplBookingV4({
        id: 1,
        quantity: "0",
        goodsPrice: "0"
      })]
      : [];
    this.commodityUserOverride = false;
    this.errors.commodity = "";
    this.errors.pieces = "";
    this.isCiplSectionValid = !this.showItemDetails;
    this.isCommoditySectionValid = false;
    this.isPackageWeightSectionValid = false;
  }

  onCiplValidationChange(isValid: boolean): void {
    this.isCiplSectionValid = isValid;
  }

  onCommodityValidationChange(isValid: boolean): void {
    this.isCommoditySectionValid = isValid;
  }

  onPackageWeightValidationChange(isValid: boolean): void {
    this.isPackageWeightSectionValid = isValid;
  }

  get exchangeRatePairSignature(): string {
    return `${this.formAccountCurrencyCode}|${this.formLocalCurrencyCode}|${
      this.bookingFormV4.receiver.destinationCountryCode
    }|${this.destinationCityDetail?.id || ""}`;
  }

  async syncActiveExchangeRate(): Promise<void> {
    const destinationCountryCode = this.bookingFormV4.receiver
      .destinationCountryCode;
    const destinationCityId = this.destinationCityDetail?.id || 0;
    if (!destinationCountryCode || !destinationCityId) {
      await BookingV4Controller.clearActiveExchangeRate();
      return;
    }
    this.carriedCiplExchangeRate = null;
    await Promise.all([
      this.fetchCountryCurrency(this.accountCountryCode),
      this.fetchCountryCurrency(destinationCountryCode)
    ]);
    const from = this.formAccountCurrencyCode;
    const to = this.formLocalCurrencyCode;
    const contextSignature = this.exchangeRatePairSignature;
    if (contextSignature === this.lastExchangeRateContextSignature) return;
    this.lastExchangeRateContextSignature = contextSignature;
    if (from === to) {
      await BookingV4Controller.clearActiveExchangeRate();
      return;
    }
    const result = await BookingV4Controller.fetchActiveExchangeRate({
      from,
      to
    });
    if (!result) this.lastExchangeRateContextSignature = "";
  }

  get ciplLocalTotal(): number {
    return this.bookingFormV4.commodityCipl.reduce((total, item) => {
      return (
        total +
        parseCiplNumber(item.quantity) *
          parseByCountry(item.goodsPrice, {
            country: this.accountCountryCode
          })
      );
    }, 0);
  }

  get activeCiplExchangeRate(): number | null {
    const rate = BookingV4Controller.activeExchangeRate;
    const from = this.formAccountCurrencyCode;
    const to = this.formLocalCurrencyCode;
    const isValid = Boolean(
      rate &&
        rate.exchangeRateFrom === from &&
        rate.exchangeRateTo === to &&
        rate.exchangeRateStatus === "active" &&
        Number.isFinite(rate.exchangeRate) &&
        rate.exchangeRate > 0
    );
    return isValid && rate ? rate.exchangeRate : null;
  }

  get ciplEstimatedConversion(): { currency: string; amount: number } | null {
    const exchangeRate = BookingV4Controller.activeExchangeRate;
    const rate = this.activeCiplExchangeRate;
    if (rate !== null && exchangeRate) {
      return {
        currency: exchangeRate.exchangeRateTo,
        amount: this.ciplLocalTotal * rate
      };
    }
    if (!this.carriedCiplExchangeRate) return null;

    return {
      currency: this.carriedCiplExchangeRate.currency,
      amount: this.ciplLocalTotal * this.carriedCiplExchangeRate.rate
    };
  }

  get ciplDeminimisThreshold(): number | null {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return null;
    }
    return this.dutyTaxResolveResult.deminimisValue;
  }

  get dutyTaxDestinationCurrency(): string {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return "";
    }
    return this.dutyTaxResolveResult.destinationCurrencyCode;
  }

  get ciplDeminimisExceeded(): boolean {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return false;
    }
    return this.dutyTaxResolveResult.deminimisExceeded;
  }

  get recipientImportDocRequired(): boolean {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return false;
    }
    return this.dutyTaxResolveResult.documentCircularRequired;
  }

  get selfClearanceRequired(): boolean {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return false;
    }
    return this.dutyTaxResolveResult.selfClearanceRequired;
  }

  // Ordered aggregation per commodity_code (frozen contract GENESIS-20446):
  // grouped by insertion order (row `id`, stable across any display
  // sort/reorder) so `first_input_index` reflects when the commodity was
  // first entered, not its current on-screen position.
  get dutyTaxResolveItems(): DutyTaxResolveItemInput[] {
    const rowsByInsertOrder = [...this.bookingFormV4.commodityCipl].sort(
      (a, b) => a.id - b.id
    );
    const groups = new Map<string, DutyTaxResolveItemInput>();
    rowsByInsertOrder.forEach((row, index) => {
      if (!row.commodityId || row.commodityId <= 0) return;
      const commodityCode = row.code;
      if (!commodityCode) return;
      const price =
        parseCiplNumber(row.quantity) *
        parseByCountry(row.goodsPrice, { country: this.accountCountryCode });
      const existing = groups.get(commodityCode);
      if (existing) {
        existing.summedPrice += price;
      } else {
        groups.set(commodityCode, {
          commodityCode,
          summedPrice: price,
          firstInputIndex: index
        });
      }
    });
    return Array.from(groups.values());
  }

  get dutyTaxResolveContextSignature(): string {
    return [
      this.ENABLE_DUTY_TAX_INFOBAR,
      this.bookingFormV4.receiver.destinationCountryCode,
      this.footerChargeableWeightKg,
      this.formAccountCurrencyCode,
      this.dutyTaxResolveItems
        .map(
          (item) =>
            `${item.commodityCode}:${item.summedPrice}:${item.firstInputIndex}`
        )
        .join(",")
    ].join("|");
  }

  getDutyTaxResolveDebounced = debounce(async () => {
    const destinationCountryCode = this.bookingFormV4.receiver
      .destinationCountryCode;
    const chargeableWeightKg = this.footerChargeableWeightKg;
    const items = this.dutyTaxResolveItems;
    if (
      !this.ENABLE_DUTY_TAX_INFOBAR ||
      !destinationCountryCode ||
      !(chargeableWeightKg > 0) ||
      !items.length
    ) {
      this.dutyTaxResolveResult = null;
      return;
    }
    try {
      this.dutyTaxResolveResult = await DutyTaxConfigurationController.resolveDutyTaxConfiguration(
        {
          destinationCountryCode: destinationCountryCode.toUpperCase(),
          chargeableWeightKg,
          originCurrency: this.formAccountCurrencyCode,
          items
        }
      );
    } catch {
      // Never blocks submit — resolve failure/timeout just hides the infobar.
      this.dutyTaxResolveResult = null;
    }
  }, 250);

  // Country-aware volumetric divisor (V3 parity) — priority: Horde map for
  // the account's country -> hardcoded FE fallback table -> 6000 default.
  get volumeWeightDivisorForSelectedProduct(): number {
    return volumeWeightForProduct(
      this.bookingFormV4?.product?.productType || "",
      ProductController.volumetricDivisorMap,
      this.accountCountryCode
    );
  }

  // Stubbed null — no HWS threshold source is owned by this subtask (PRD
  // §3.8 notes the config is BE-managed via rollout without a documented FE
  // endpoint here); package-weight.vue already treats null as "no HWS alert".
  heavyWeightSurchargeConfig = new HeavyWeightSurchargeData();
  heavyWeightSurchargeConfigBigpack = new HeavyWeightSurchargeData();
  heavyWeightSurchargeMinimumConfig = new HwsThresholdConfig();
  tempProductName = "";

  getHWSConfig = debounce(async () => {
    try {
      const resp = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
        { id: 1 }
      );
      const respBigpack = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
        { id: 2 }
      );
      this.heavyWeightSurchargeConfig = resp;
      this.heavyWeightSurchargeConfigBigpack = respBigpack;
    } catch (err) {
      this.heavyWeightSurchargeMinimumConfig = new HwsThresholdConfig();
    }
  }, 500);

  get hwsConfigForSelectedProduct(): HwsThresholdConfig {
    const productName =
      this.bookingFormV4.product.productType || this.tempProductName;
    if (
      !this.heavyWeightSurchargeConfig.configurableHeavyWeight ||
      !this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight
    )
      return new HwsThresholdConfig();
    const isActive =
      this.heavyWeightSurchargeConfig.configurablePriceStatus.toLowerCase() ||
      this.heavyWeightSurchargeConfigBigpack.configurablePriceStatus.toLowerCase() ===
        "active";
    const product = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );
    const productBigpack = this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );
    const isEnableHwsConfig = FlagsPermissionBooking.hws_configuration.isEnabled();
    const commodity = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_commodity_exclude.commodities.find(
      (item: any) =>
        item.commodity_code === this.bookingFormV4.commodity.code ||
        item.commodity_name === this.bookingFormV4.commodity.name
    );
    const commodityBigpack = this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight.heavy_weight_surcharge_commodity_exclude.commodities.find(
      (item: any) =>
        item.commodity_code === this.bookingFormV4.commodity.code ||
        item.commodity_name === this.bookingFormV4.commodity.name
    );

    const otherCondition =
      (product || productBigpack) && (!commodity || !commodityBigpack);
    const isSetMinimumHws = isActive && otherCondition && isEnableHwsConfig;
    if (isSetMinimumHws) {
      return new HwsThresholdConfig({
        minimumWeightKg: productBigpack
          ? this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight
              .heavy_weight_surcharge_additional_cost.additional_costs[0]
              ?.weight_min
          : this.heavyWeightSurchargeConfig.configurableHeavyWeight
              .heavy_weight_surcharge_additional_cost.additional_costs[0]
              ?.weight_min,
        minimumExist: true
      });
    }

    return new HwsThresholdConfig();
  }

  // --- Route-level derive getters (SSOT — re-evaluate reactively on tab /
  // origin district / destination / product change; consumed by section
  // wiring subtasks GENESIS-20155–20161) ---
  get activeTab(): BookingTabV4Value {
    return this.bookingFormV4.pageMeta.activeTab;
  }

  get receiptFormat(): ReceiptFormatV4Value {
    return this.bookingFormV4.pageMeta.receiptFormat;
  }

  // Origin district (pengirim) — shared controller state, mirrors v3.
  get districtDetail(): DistrictData {
    return LocationController.districtDetail;
  }

  get accountIsNonForeign(): boolean {
    return !AccountController.accountData.accountIsForeign;
  }

  get accountCountryCode(): string {
    return AccountController.accountData.countryCode;
  }

  get isFtz(): boolean {
    return AccountController.accountData.account_type === "internal"
      ? this.districtDetail.isFtz === "yes"
      : AccountController.accountData.account_location?.city_free_trade_zone ===
          "yes" && this.accountIsNonForeign;
  }

  get destinationCityDetail(): DistrictData | null {
    const destination = this.bookingFormV4.receiver.destinationCity;
    return typeof destination === "string" ? null : destination;
  }

  get isCipl(): boolean {
    return this.activeTab === BookingTabV4.INTERNATIONAL;
  }

  get isFtzForm(): boolean {
    return this.activeTab === BookingTabV4.DOMESTIC && this.isFtz;
  }

  get showItemDetails(): boolean {
    return this.isCipl || this.isFtzForm;
  }

  get showSupportingDocSection(): boolean {
    return this.isCipl || this.isFtzForm;
  }

  get supportingDocContextSignature(): string {
    return [
      this.districtDetail.cityId,
      this.destinationCityDetail?.cityId || 0,
      this.isCipl,
      this.isFtzForm,
      this.isPosAccount
    ].join("|");
  }

  seedRetailDutyTaxTerms(): void {
    const docInternational = this.bookingFormV4.supportingDoc.docInternational;
    if (!docInternational.dutyTaxTerms) {
      docInternational.dutyTaxTerms = "DAP";
    }
  }

  async getRoundingRulesConfig(): Promise<void> {
    try {
      const resp = await BookingV4Controller.fetchProductConfigurationRule(
        new ProductConfigurationRuleRequestParamsV4({
          page: 1,
          limit: 10,
          isNoLimit: true,
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.configurationRules = resp || [];
    } catch {
      this.configurationRules = [];
    }
  }

  async fetchSupportingDocFieldRules(): Promise<void> {
    const requestId = ++this.supportingDocRulesRequestId;
    this.supportingDocFieldRulesReady = false;
    this.isSupportingDocSectionValid = false;

    if (!this.showSupportingDocSection) {
      this.supportingDocFieldRules = {};
      return;
    }
    if (this.isFtzForm) {
      this.supportingDocFieldRules = {};
      this.supportingDocFieldRulesReady = true;
      this.isItemDetailsRequired = true;
      return;
    }

    this.seedRetailDutyTaxTerms();
    const origin = this.districtDetail.cityId;
    const dest = this.destinationCityDetail?.cityId || 0;
    if (!origin || !dest) return;

    try {
      const detail = await InternationalDocumentController.getInternationalDocumentDetail(
        {
          origin,
          dest
        }
      );
      if (requestId !== this.supportingDocRulesRequestId) return;
      this.supportingDocFieldRulesReady = true;
      this.supportingDocFieldRules = this.mapSupportingDocFieldRules(detail);
      this.isItemDetailsRequired = detail.commodity;
    } catch (_error) {
      if (requestId !== this.supportingDocRulesRequestId) return;
      this.supportingDocFieldRules = {};
      this.isItemDetailsRequired = true;
    }
  }

  mapSupportingDocFieldRules(
    detail: RequestInternationalDocumentDetail
  ): Partial<Record<SupportingDocCompletionFieldKey, SttAdjustmentRule>> {
    const rule = (isRequired: boolean) => new SttAdjustmentRule({ isRequired });
    return {
      email: rule(detail.email),
      idNumber: rule(detail.idcIsIdentityNumber),
      taxNumber: rule(detail.idcIsTaxIdentificationNumber),
      imageId: rule(detail.ktp),
      imageTax: rule(detail.npwp),
      imageBeforePacking: rule(detail.afterPacking),
      imageAfterPacking: rule(detail.afterPacking)
    };
  }

  get isReferenceRequired(): boolean {
    return this.bookingFormV4.isReferenceRequired;
  }

  // Account session -> ReferenceNumberV4's AccountTypeV4 (pos/client/internal).
  // Mirror v3's stt-manual-reference accountType ternary (create-booking-v3/
  // components/stt-manual-reference/index.vue), extended to the 3rd branch
  // since AccountTypeV4 covers internal too — intentionally NOT the 19582
  // getter SSOT (out of scope, per detailing).
  get accountType(): AccountTypeV4 {
    if (AccountController.accountData.isInternalAccount) return "internal";
    if (AccountController.accountData.isAllClient) return "client";
    return "pos";
  }

  // --- Form completion state engine (GENESIS-19583) ---
  // Section validity placeholders: GENESIS-20156 (reference), 20157
  // (barang/koli) and 20158 (dokpend) mount their section components and
  // assign real values here from `@validationChange` — until then these
  // default incomplete so formCompletionItems / the panel reflect a
  // not-yet-filled form rather than a fabricated "complete" state.
  // Sender/Receiver wired by GENESIS-20155 — driven by
  // onSenderValidationChange / onReceiverValidationChange above.
  isSenderSectionValid = false;
  isReceiverSectionValid = false;
  isReferenceSectionValid = false;
  isCommoditySectionValid = false;
  isPackageWeightSectionValid = false;
  isCiplSectionValid = false;
  isSupportingDocSectionValid = false;
  supportingDocFieldRules: Partial<
    Record<SupportingDocCompletionFieldKey, SttAdjustmentRule>
  > = {};
  supportingDocFieldRulesReady = false;
  supportingDocRulesRequestId = 0;
  configurationRules: ProductConfigurationRule[] = [];

  // Set true by the submit handler landing in GENESIS-19586 (mirror v3
  // post-submit highlight — sections don't show the red "error" state until
  // the user has attempted at least one submit).
  hasAttemptedSubmit = false;

  /* Set by onSubmit() step 4 (Limit Tagihan guard) — drives the pre-submit
  // insufficient-limit message next to PaymentMethodSelectorV4.
  isLimitTagihanInsufficient = false;
  */

  /* --- Voucher / OTP orchestration (GENESIS-19592) ---
  // Mirrors create-booking-v3's voucher state; `bookingFormV4.voucher`
  // (VoucherBookingV4) holds only the submission-relevant subset (persisted
  // per GENESIS-19759), so `appliedVoucherItem` mirrors the full
  // BookingVoucherItem (isOtpRequired, discount info, ...) for display —
  // same split v3 keeps between `appliedVoucher` and the submit payload.
  isSeeMoreExpanded = false;
  loadingVoucherList = false;
  loadingVoucherManual = false;
  voucherItems: BookingVoucherItem[] = [];
  voucherPagination = new BookingVoucherPagination();
  voucherTermsVoucher = new BookingVoucherItem();
  voucherManualCode = "";
  voucherManualError = "";
  appliedVoucherItem = new BookingVoucherItem();
  isOtpVoucherModalVisible = false;
  loadingIssueOtpVoucher = false;
  loadingVerifyOtpVoucher = false;
  otpVoucherErrorMessage = "";
  otpVoucherExpiresAt = "";
  */

  get isMaxTotalGrossweight() {
    return (
      this.bookingFormV4.pieces.reduce((prev, curr) => {
        return prev + curr.grossWeight;
      }, 0) > 400
    );
  }

  get isMaxTotalVolumeweight() {
    return (
      this.bookingFormV4.pieces.reduce((prev, curr) => {
        return prev + curr.volumeWeight;
      }, 0) > 400
    );
  }

  get isGoodsPiecesSectionValid(): boolean {
    return (
      this.isCommoditySectionValid &&
      this.isPackageWeightSectionValid &&
      (!this.showItemDetails || this.isCiplSectionValid) &&
      !this.isMaxTotalGrossweight &&
      !this.isMaxTotalVolumeweight
    );
  }

  // --- Submit orchestration (GENESIS-19586) ---
  // Aggregate gate for onSubmit() step 1 (validasi umum) — mirrors the same
  // per-section flags shouldShowSectionValidationError() already reads.
  get isAllSectionValid(): boolean {
    return (
      this.isSenderSectionValid &&
      this.isReceiverSectionValid &&
      (!this.isReferenceRequired || this.isReferenceSectionValid) &&
      this.isGoodsPiecesSectionValid &&
      !!this.bookingFormV4.product.productType &&
      !!this.bookingFormV4.paymentMethod.method &&
      (!this.showSupportingDocSection || this.isSupportingDocSectionValid) &&
      !!this.bookingFormV4.protectionPacking.itemPrice &&
      !String(this.errors.itemPrice).length
    );
  }

  /* // onSubmit() step 2 (voucher gate), owned by GENESIS-19592: true when no
  // OTP validation is disabled, no voucher is applied, the applied voucher
  // needs no OTP, or all OTP fields are populated.
  get isVoucherSubmitReady(): boolean {
    const voucher = this.bookingFormV4.voucher;
    if (!FlagsPermissionBookingV3.config_validate_otp_voucher_hq.isEnabled()) {
      return true;
    }
    if (!voucher.appliedVoucherCode) return true;
    if (!this.appliedVoucherItem.isOtpRequired) return true;
    return !!(
      voucher.otpCode &&
      voucher.otpToken &&
      voucher.goberReservationId
    );
  }
  */

  isEnterSubmitting = false;

  async onEnterSubmit(event: KeyboardEvent): Promise<void> {
    if (this.isEnterSubmitting || !shouldSubmitBookingOnEnter(event)) {
      return;
    }

    this.isEnterSubmitting = true;
    event.preventDefault();
    try {
      await this.onSubmit();
    } finally {
      this.isEnterSubmitting = false;
    }
  }

  async onSubmit(): Promise<void> {
    try {
      this.hasAttemptedSubmit = true;
      this.triggerAllFormErrors();
      this.isShowModalFailedBooking = false;

      if (!this.isAllSectionValid) {
        MainAppController.showErrorMessage(
          new ErrorMessageEntities({
            title: this.$t("bookingV4.validationError") as string,
            message: this.$t("bookingV4.completeForm") as string,
            type: CLIENT_ERROR,
            onTryAgain: () => {
              MainAppController.closeErrorMessage();
              const firstErrorSection = this.formCompletionItems.find(
                (item) => item.state === "error"
              );
              if (firstErrorSection) {
                this.onFormCompletionNavigate(firstErrorSection.key);
              }
            }
          })
        );
        return;
      }

      /*
      if (
        this.bookingFormV4.voucher.appliedVoucherCode &&
        this.appliedVoucherItem.isOtpRequired &&
        !this.bookingFormV4.voucher.otpCode &&
        FlagsPermissionBookingV3.config_validate_otp_voucher_hq.isEnabled()
      ) {
        if (!this.bookingFormV4.voucher.otpToken) {
          await this.issueOtpVoucherIfNeeded();
        } else {
          this.isOtpVoucherModalVisible = true;
        }
        return;
      }

      if (!this.isVoucherSubmitReady) {
        return;
      }
      */

      /* Invoice Limit is not available on MY retail branch.
      this.isLimitTagihanInsufficient = false;
      if (
        this.bookingFormV4.paymentMethod.method ===
          PaymentMethodV4.INVOICE_LIMIT &&
        this.paymentEligibility.posLimit.remainingLimit <
          this.bookingFormV4.estimationPrice.finalPrice
      ) {
        this.isLimitTagihanInsufficient = true;
      }
      */

      if (!this.insuranceBasic.isAvailable) {
        this.bookingFormV4.protectionPacking.insuranceType = "free";
      }

      MainAppController.showLoading();
      const resp = await BookingV4Controller.addManualBooking(
        this.assembleSubmitPayload()
      );
      this.runCarryOverAfterSubmit(resp);
      this.savePackage = false;
      MainAppController.closeLoading();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      this.fetchSavedPackages(this.bookingFormV4.sender.id);
    } catch (error) {
      this.handleErrorBooking(error);
    } finally {
      MainAppController.closeLoading();
    }
  }

  // Trigger owner (GENESIS-19586): fires immediately once submit succeeded
  // and sttNo is present in the response — deliberately not gated on the
  // success popup (GENESIS-19587), which stays an independent overlay
  // (PRD §3.21 AC #1).
  async runCarryOverAfterSubmit(resp: ResponsePayload) {
    const sttNo = resp?.sttNumber || resp?.data?.stt?.[0]?.stt_no || "";
    if (!resp?.success || !sttNo) return;
    const carryOverSnapshot = this.buildCarryOverSnapshot();

    PrintReceiptController.addListSttSuccessBooking(sttNo);
    if (PrintReceiptController.setLastDateSttSuccessBooking) {
      PrintReceiptController.setLastDateSttSuccessBooking();
    }

    this.successBookingData = resp.data || new SuccessBookingV4();
    this.productUpsellingData = [];
    this.isSuccessModalVisible = true;
    await this.onPrintSuccessReceipt(resp.sttId, resp.sttNumber);
    this.$refs.headerBooking.syncListHistorySuccessBooking();
    this.$refs.refNumber.inputValue = "";
    this.applyCarryOver(carryOverSnapshot);
    window.dispatchEvent(new Event("success-booking"));
    window.dispatchEvent(new Event("success-booking-retail"));
    const res = await ShipmentBookingController.getEditBookingDetail({
      id: resp.sttNumber as any,
      sttNo: resp.sttNumber as any,
      isAuth: true,
      pageType: "duplicate_stt"
    });
    if (res instanceof ShipmentBookingDetail)
      this.bookingFormV4.sender.id = res.sttSenderCustomerId;
    this.onSetInsurance();
  }

  buildCarryOverSnapshot(): CarryOverSnapshotV4 {
    return {
      activeTab: this.bookingFormV4.pageMeta.activeTab,
      sender: new SenderBookingV4({ ...this.bookingFormV4.sender }),
      commodity: new CommodityBookingV4({ ...this.bookingFormV4.commodity }),
      pieces: this.bookingFormV4.pieces.map(
        (piece) => new PieceBookingV4({ ...piece })
      ),
      commodityCipl: this.bookingFormV4.commodityCipl.map(
        (cipl) => new CommodityCiplBookingV4({ ...cipl })
      ),
      ciplExchangeRate: this.ciplEstimatedConversion
        ? {
            currency: this.ciplEstimatedConversion.currency,
            rate: this.activeCiplExchangeRate || 0
          }
        : null,
      productType: this.bookingFormV4.product.productType
    };
  }

  async printInterpack(
    headerData: PrintDataEntitas,
    pageSize: "a4" | "a6" = "a4"
  ) {
    MainAppController.showLoading();
    try {
      const logo = await import("@/app/ui/assets/images/logo-lion-parcel.png");
      const locales = AccountController.accountData.account_type_detail.countryCode?.toLowerCase();
      if (!headerData.currencyCode)
        headerData.currencyCode = this.formCurrencyPrefix.toUpperCase();
      generateCommercialInvoiceV2(
        headerData,
        logo.default,
        locales === "my" ? "my" : undefined,
        pageSize
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onPrintSuccessReceipt(sttId: number, sttNo: string): Promise<void> {
    const targetSttNo = sttNo || this.successBookingData?.stt?.[0]?.sttNo;
    const targetSttId = sttId || this.successBookingData?.stt?.[0]?.sttId;

    if (!targetSttNo) return;

    const format = this.bookingFormV4.pageMeta.receiptFormat; // "a6" | "a4" | "none"
    if (format === "none") return;

    try {
      const isSuccess = await this.generatePrintData(targetSttId, targetSttNo);

      const printDataEntitas = BookingController.generatePrintData;
      const isValidData =
        isSuccess && printDataEntitas && Boolean(printDataEntitas.sttNo);

      if (isValidData) {
        const preparedPrintPieces = this.preparePrintDataPieces([
          printDataEntitas
        ]);

        const accountType =
          AccountController.accountData.account_type === "partner"
            ? AccountController.accountData.account_type_detail.type
            : AccountController.accountData.account_type;

        if (format === "a6") {
          await bulkLabelResiThermal(
            accountType,
            preparedPrintPieces,
            [],
            false,
            this.accountCountryCode.toLowerCase() as any
          );
        } else if (format === "a4") {
          await bulkLabelResiPdf(
            accountType,
            preparedPrintPieces,
            [],
            this.accountCountryCode.toLowerCase() as any
          );
        }

        if (this.isCipl) this.printInterpack(printDataEntitas, format);
      } else {
        console.warn(
          "[Print Receipt] Data cetak resi tidak valid atau gagal diambil."
        );
      }
    } catch (error) {
      console.error("Gagal memproses data cetak resi:", error);
    }
  }

  async generatePrintData(sttId: any, sttNo: string) {
    const accountType =
      AccountController.accountData.account_type === "partner"
        ? AccountController.accountData.account_type_detail.type
        : AccountController.accountData.account_type;

    return await BookingController.getPrintDataByStt(
      new PrintDetailRequest({
        sttNo: sttNo,
        id: sttId,
        accountType: accountType
      })
    );
  }

  preparePrintDataPieces(dataList: PrintDataEntitas[]): any[] {
    const listSttPieces: any[] = [];

    dataList.forEach((item) => {
      if (!item) return;

      const barcodeImg = document.createElement("img");
      JsBarcode(barcodeImg, item.sttNo, {
        textAlign: "left",
        displayValue: false,
        fontSize: 16
      });

      const vendorBarcodeImg = document.createElement("img");
      if (item.sttVendorRefferenceNo) {
        JsBarcode(vendorBarcodeImg, item.sttVendorRefferenceNo, {
          textAlign: "left",
          displayValue: false,
          fontSize: 16
        });
      }

      const pieces = item.sttPieces?.length ? item.sttPieces : [item];

      pieces.forEach((piece: any) => {
        listSttPieces.push({
          ...piece,
          ...item,
          barcode: barcodeImg.src,
          vendorRefCode: item.sttVendorRefferenceNo ? vendorBarcodeImg.src : ""
        });
      });

      barcodeImg.remove();
      vendorBarcodeImg.remove();
    });

    return listSttPieces;
  }

  // Retains Tab/Pengirim/Barang & Koli/Jenis Pengiriman; every other section
  // resets to its CreateBookingV4 default (PRD §3.21 AC #2/#4). Jenis
  // Pengiriman only gets its initial default + carryOverProductName flag here
  // — route-eligibility re-eval on destination change is owned by
  // GENESIS-20159 (ProductCardList wiring), consuming carryOverProductName.
  applyCarryOver(snapshot: CarryOverSnapshotV4): void {
    this.isRebookingFlow = true;
    this.carryOverProductName = snapshot.productType || null;
    this.carriedCiplExchangeRate = snapshot.ciplExchangeRate;

    Object.assign(
      this.bookingFormV4,
      new CreateBookingV4({
        pageMeta: new PageMetaBookingV4({ activeTab: snapshot.activeTab }),
        sender: snapshot.sender,
        receiver: new ReceiverBookingV4({
          phoneCode: !this.isAccountForeignPos ? "+62" : "+60",
          phoneFlag: !this.isAccountForeignPos ? "indonesia" : "malaysia"
        }),
        commodity: snapshot.commodity,
        pieces: snapshot.pieces,
        commodityCipl: snapshot.commodityCipl,
        product: new ProductBookingV4({ productType: snapshot.productType }),
        bookingHistory: this.bookingFormV4.bookingHistory,
        references: []
      })
    );
    this.errors = new ErrorBookingV4();

    // Reset validity of only the sections that reset to default — Sender and
    // Barang & Koli carried real data over and keep whatever validity state
    // their section components already report.
    this.isReceiverSectionValid = false;
    this.isReferenceSectionValid = false;
    this.isSupportingDocSectionValid = false;
    this.hasAttemptedSubmit = false;
    // this.isLimitTagihanInsufficient = false;
  }

  isShowModalFailedBooking = false;
  modalFailedBookingData = new FailedBookingData();
  handleErrorBooking(err: any) {
    if (this.handleOtpVoucherBookingError(err)) return;

    this.isShowModalFailedBooking = true;
    const message = err?.response?.data?.message;

    const errorType =
      message?.error_type ||
      (this.accountIsNonForeign ? message?.id : message?.en) ||
      "";
    this.modalFailedBookingData = new FailedBookingData({
      error: !err?.response
        ? ""
        : err?.response?.status > 500
        ? "SYSTEM"
        : errorType,
      balance: message?.balance || 0,
      price: message?.price || message?.tariff || 0
    });

    const messageId = message?.id;
    const messageEn = message?.en;
    const isVoucherInvalid =
      /voucher/i.test(String(messageId || "")) ||
      /voucher/i.test(String(messageEn || "")) ||
      /voucher/i.test(String(errorType || ""));

    if (isVoucherInvalid) {
      this.clearAppliedVoucherAndRefresh();
      // this.fetchVoucherList();
    }
  }

  handleOtpVoucherBookingError(err: any): boolean {
    // if (!this.showVoucherOtpBanner) return false;
    if (!this.bookingFormV4.voucher.otpToken?.trim()) return false;
    if (!this.bookingFormV4.voucher.otpCode) return false;

    const messageId = err?.response?.data?.message?.id;
    const messageEn = err?.response?.data?.message?.en;
    const messageRaw = err?.response?.data?.message;
    const errorType = err?.response?.data?.message?.error_type;

    const msg =
      (typeof messageId === "string" && messageId) ||
      (typeof messageEn === "string" && messageEn) ||
      (typeof messageRaw === "string" && messageRaw) ||
      "";

    const isOtpError =
      /otp/i.test(String(msg)) || /otp/i.test(String(errorType || ""));

    if (!isOtpError) return false;

    // this.otpVoucherErrorMessage = msg?.trim()
    //   ? msg
    //   : "Kode OTP salah, cek & coba lagi";
    // this.bookingFormV4.voucher.otpCode = "";
    // this.isOtpVoucherModalVisible = true;
    return true;
  }

  async clearAppliedVoucherAndRefresh() {
    const hadVoucher = !!this.bookingFormV4.voucher.appliedVoucherCode;
    this.bookingFormV4.voucher.appliedVoucherCode = "";
    // this.resetOtpVoucherState();
    // this.voucherManualError = "";
    // this.closeVoucherTerms();

    if (hadVoucher) {
      await this.getEstimationPrice();
    }
  }

  shouldShowSectionValidationError(
    sectionKey: FormCompletionSectionKeyV4Value
  ): boolean {
    if (
      sectionKey === FormCompletionSectionKeyV4.REFERENCE_NUMBER &&
      !this.isReferenceRequired
    ) {
      return false;
    }

    const sectionMinIndex: Partial<Record<
      FormCompletionSectionKeyV4Value,
      number
    >> = {
      [FormCompletionSectionKeyV4.SENDER]: 1,
      [FormCompletionSectionKeyV4.RECEIVER]: 5,
      [FormCompletionSectionKeyV4.REFERENCE_NUMBER]: 9,
      [FormCompletionSectionKeyV4.GOODS_PIECES]: 11,
      [FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS]: 20
    };

    const minIndex = sectionMinIndex[sectionKey];
    const isBypassed =
      minIndex !== undefined &&
      this.currentIndex !== -1 &&
      (this.currentIndex === 11 || this.currentIndex > minIndex + 3);

    const shouldEvaluate = this.hasAttemptedSubmit || isBypassed;
    if (!shouldEvaluate) return false;

    switch (sectionKey) {
      case FormCompletionSectionKeyV4.SENDER:
        return !this.isSenderSectionValid;
      case FormCompletionSectionKeyV4.RECEIVER:
        return !this.isReceiverSectionValid;
      case FormCompletionSectionKeyV4.REFERENCE_NUMBER:
        return this.isReferenceRequired && !this.isReferenceSectionValid;
      case FormCompletionSectionKeyV4.GOODS_PIECES:
        return !this.isGoodsPiecesSectionValid;
      case FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS:
        return (
          this.showSupportingDocSection && !this.isSupportingDocSectionValid
        );
      case FormCompletionSectionKeyV4.PRODUCT_TYPE:
        return !this.bookingFormV4.product.productType;
      default:
        return false;
    }
  }

  resolveSectionCompletionState(
    sectionKey: FormCompletionSectionKeyV4Value,
    isValid: boolean
  ): string {
    if (isValid) return FormCompletionSectionStateV4.COMPLETE;
    return this.shouldShowSectionValidationError(sectionKey)
      ? "error"
      : FormCompletionSectionStateV4.INCOMPLETE;
  }

  get supportingDocCompletionFields(): FormCompletionFieldRowV4[] {
    return SUPPORTING_DOC_COMPLETION_FIELD_ORDER.filter(
      (fieldKey) =>
        !!this.supportingDocFieldRules[fieldKey] &&
        this.supportingDocFieldRules?.[fieldKey]?.isRequired
    ).map((fieldKey) => {
      const rule = this.supportingDocFieldRules[fieldKey] as SttAdjustmentRule;
      return new FormCompletionFieldRowV4({
        fieldKey,
        fieldLabel: this.$t(
          SUPPORTING_DOC_FIELD_LABEL_I18N[fieldKey]
        ) as string,
        status: rule.isRequired ? "wajib" : "opsional"
      });
    });
  }

  get formCompletionItems(): FormCompletionPanelItemV4[] {
    const items: FormCompletionPanelItemV4[] = [
      new FormCompletionSectionBookingV4({
        key: FormCompletionSectionKeyV4.SENDER,
        label: this.$t("bookingV4.formCompletion.sender") as string,
        state: this.resolveSectionCompletionState(
          FormCompletionSectionKeyV4.SENDER,
          this.isSenderSectionValid
        )
      }),
      new FormCompletionSectionBookingV4({
        key: FormCompletionSectionKeyV4.RECEIVER,
        label: this.$t("bookingV4.formCompletion.recipient") as string,
        state: this.resolveSectionCompletionState(
          FormCompletionSectionKeyV4.RECEIVER,
          this.isReceiverSectionValid
        )
      })
    ];

    if (this.isReferenceRequired) {
      items.push(
        new FormCompletionSectionBookingV4({
          key: FormCompletionSectionKeyV4.REFERENCE_NUMBER,
          label: this.$t("bookingV4.formCompletion.referenceNumber") as string,
          state: this.resolveSectionCompletionState(
            FormCompletionSectionKeyV4.REFERENCE_NUMBER,
            this.isReferenceSectionValid
          )
        })
      );
    }

    items.push(
      new FormCompletionSectionBookingV4({
        key: FormCompletionSectionKeyV4.GOODS_PIECES,
        label: this.$t("bookingV4.formCompletion.goods") as string,
        state: this.resolveSectionCompletionState(
          FormCompletionSectionKeyV4.GOODS_PIECES,
          this.isGoodsPiecesSectionValid
        )
      })
    );

    // items.push(
    //   new FormCompletionSectionBookingV4({
    //     key: FormCompletionSectionKeyV4.PRODUCT_TYPE,
    //     label: this.$t("bookingV4.product.title") as string,
    //     state: this.resolveSectionCompletionState(
    //       FormCompletionSectionKeyV4.PRODUCT_TYPE,
    //       !!this.bookingFormV4.product.productType
    //     )
    //   })
    // );

    if (this.showSupportingDocSection) {
      const supportingDocumentsItem: FormCompletionPanelItemV4 = new FormCompletionSectionBookingV4(
        {
          key: FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS,
          label: this.$t("bookingV4.formCompletion.doc") as string,
          state: this.resolveSectionCompletionState(
            FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS,
            this.isSupportingDocSectionValid
          )
        }
      );
      supportingDocumentsItem.fields = this.supportingDocCompletionFields;
      items.push(supportingDocumentsItem);
    }

    return items;
  }

  onFormCompletionNavigate(sectionKey: FormCompletionSectionKeyV4Value) {
    const anchorId = FORM_COMPLETION_SECTION_ANCHORS[sectionKey];
    document.getElementById(anchorId)?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }

  // Account POS Malaysia — static per session, not destination-driven.
  get isAccountForeignPos(): boolean {
    return !this.accountIsNonForeign;
  }

  // --- Cross-cutting locale, currency & numeric SSOT getters (reuse
  // FormatPriceRP/RM, configPrice, getCurrencyByCountryCode) ---
  get formLocalCurrencyCode(): string {
    return this.resolveCountryCurrency(
      this.bookingFormV4.receiver.destinationCountryCode
    );
  }

  get formCurrencyPrefix(): string {
    return configPrice[this.formAccountCurrencyCode]?.prefix ?? "Rp";
  }

  // Country of the account/POS — static per session, not re-eval on destination change.
  get formAccountCurrencyCode(): string {
    return this.resolveCountryCurrency(this.accountCountryCode);
  }

  resolveCountryCurrency(countryCode: string): string {
    return (
      this.countryCurrencyByCode[countryCode.toUpperCase()] ||
      getCurrencyByCountryCode(countryCode)
    );
  }

  async fetchCountryCurrency(countryCode: string): Promise<void> {
    const normalizedCode = countryCode.toUpperCase();
    if (this.countryCurrencyByCode[normalizedCode]) return;
    if (this.countryCurrencyRequests[normalizedCode]) {
      return this.countryCurrencyRequests[normalizedCode];
    }

    const countryName = COUNTRY_OPTIONS.find(
      (country) => country.countryCode === normalizedCode
    )?.name;
    if (!countryName) return;

    const request = this.loadCountryCurrency(normalizedCode, countryName);
    this.countryCurrencyRequests[normalizedCode] = request;
    try {
      await request;
    } finally {
      delete this.countryCurrencyRequests[normalizedCode];
    }
  }

  async loadCountryCurrency(
    countryCode: string,
    countryName: string
  ): Promise<void> {
    const response = await LocationController.getCountryList({
      search: countryName,
      status: "active",
      page: 1,
      limit: 10
    });
    const country = response?.countryData.find(
      (item) => item.code.toUpperCase() === countryCode
    );
    if (!country?.currency) return;
    this.countryCurrencyByCode = {
      ...this.countryCurrencyByCode,
      [countryCode]: country.currency.toUpperCase()
    };
  }

  get formAccountCurrencyPrefix(): string {
    return configPrice[this.formAccountCurrencyCode]?.prefix ?? "Rp";
  }

  get formAccountNumericLocale(): "id" | "my" {
    return NUMERIC_LOCALE_BY_CURRENCY[this.formAccountCurrencyCode] ?? "id";
  }

  get formNumericLocale(): "id" | "my" {
    return NUMERIC_LOCALE_BY_CURRENCY[this.formAccountCurrencyCode] ?? "id";
  }

  get isDestinationForeign(): boolean {
    return isMalaysiaDistrict(
      this.bookingFormV4.receiver.destinationCountryCode
    );
  }

  // --- COD/DFOD eligibility + Limit Tagihan orchestration (GENESIS-19584) ---
  // Port dari V3 delivery-service/index.vue getter (394-420) — adapted to
  // bookingFormV4/AccountController state (v4 retail-only host has no
  // per-client override, unlike V3's client corporate flow).
  get isPosAccount(): boolean {
    return AccountController.accountData.isPosAccount;
  }

  get isNonClientAccount(): boolean {
    return (
      AccountController.accountData.isAllPartner ||
      AccountController.accountData.isInternalAccount
    );
  }

  get isForeignAccount(): boolean {
    return AccountController.accountData.accountIsForeign;
  }

  get isEligibleDestinationCOD(): boolean {
    if (!this.destinationCityDetail?.id) return true;
    return this.destinationCityDetail.isCod === "yes";
  }

  get isEligiblePartnerCOD(): boolean {
    if (this.isForeignAccount) return false;
    if (!this.isPosAccount) return true;
    return AccountController.accountData.account_type_detail
      .partnerIsCodBooking;
  }

  // v4 create-booking-manual is retail-only (no client corporate sub-flow),
  // so V3's clientManagementDetail branch collapses: POS and non-client
  // (internal/all-partner) accounts have no client override and default
  // eligible; any other account type reads account_type_detail directly.
  get isEligibleClientCOD(): boolean {
    if (this.isPosAccount) return true;
    if (this.isNonClientAccount) return true;
    return AccountController.accountData.account_type_detail.isCod;
  }

  get isEligibleClientDFOD(): boolean {
    if (this.isPosAccount) return true;
    if (this.isNonClientAccount) return true;
    return AccountController.accountData.account_type_detail.isDfod;
  }

  get isPhoneNumberBlacklist(): boolean {
    return BookingController.phoneCheckerData.isBlacklist;
  }

  get isPhoneNumberLimit(): boolean {
    return (
      BookingController.phoneCheckerData.status === FraudStatus.LIMITED &&
      FlagsPermissionBooking.disable_cod_dfod_for_limited_number.isEnabled()
    );
  }

  get isEligibleProductTypeCOD() {
    if (!this.bookingFormV4.product.productType) return true;

    return this.ccoCodActive.ccoProductType
      .split(",")
      .some((item) => item === this.bookingFormV4.product.productType);
  }

  get isEligibleProductTypeDFOD() {
    if (!this.bookingFormV4.product.productType) return true;

    return this.ccoDfodActive.ccoProductType
      .split(",")
      .some((item) => item === this.bookingFormV4.product.productType);
  }

  get disabledCODMessage(): string {
    if (this.isPhoneNumberBlacklist) {
      return this.$t("bookingV4.payment.disable.blacklist") as string;
    }
    if (this.isPhoneNumberLimit) {
      return this.$t("bookingV4.payment.disable.dailyLimit") as string;
    }
    if (!this.isEligiblePartnerCOD) {
      return this.$t("bookingV4.payment.disable.partner") as string;
    }
    if (!this.isEligibleClientCOD) {
      return this.$t("bookingV4.payment.disable.client") as string;
    }
    if (!this.isEligibleDestinationCOD) {
      return this.$t("bookingV4.payment.disable.destination") as string;
    }
    if (!this.isEligibleProductTypeCOD) {
      return this.$t("bookingV4.payment.disable.productType") as string;
    }
    return this.$t("bookingV4.payment.disable.generic") as string;
  }

  get disabledDFODMessage(): string {
    if (!this.isEligibleClientDFOD) {
      return this.$t("bookingV4.payment.disable.client") as string;
    }
    if (!this.isEligibleProductTypeDFOD) {
      return this.$t("bookingV4.payment.disable.productType") as string;
    }
    // Destination/partner/fraud share the same eligibility gate as COD (§3.14).
    return this.disabledCODMessage;
  }

  get isPhoneNumberFraud() {
    return [this.isPhoneNumberLimit, this.isPhoneNumberBlacklist].some(Boolean);
  }

  // Retail COD/DFOD gating by route country:
  // - origin non-ID (any non-ID origin) cannot use COD/DFOD
  // - origin ID to a non-ID destination cannot use COD/DFOD
  // Only applies once a destination is selected; empty destination keeps COD enabled.
  get isRetailRouteCodDisabled(): boolean {
    if (!this.destinationCityDetail?.id) return false;
    const originCode = (
      this.districtDetail.countryCode || ""
    ).toUpperCase();
    const destCode = (
      this.destinationCityDetail.countryCode ||
      this.bookingFormV4.receiver.destinationCountryCode ||
      ""
    ).toUpperCase();
    if (!originCode || !destCode) return false;
    if (originCode !== "ID") return true;
    return destCode !== "ID";
  }

  get paymentEligibility(): PaymentEligibilityV4 {
    return {
      cod: {
        disabled: [
          !this.isEligibleDestinationCOD,
          !this.isEligiblePartnerCOD,
          !this.isEligibleClientCOD,
          !this.isEligibleProductTypeCOD,
          this.isPhoneNumberFraud,
          this.isRetailRouteCodDisabled
        ].some(Boolean),
        hoverCopy: this.disabledCODMessage
      },
      dfod: {
        disabled: [
          !this.isEligibleClientDFOD,
          !this.isEligibleDestinationCOD,
          !this.isEligiblePartnerCOD,
          !this.isEligibleProductTypeDFOD,
          this.isPhoneNumberFraud,
          this.isRetailRouteCodDisabled
        ].some(Boolean),
        hoverCopy: this.disabledDFODMessage
      }
      /* Invoice Limit is not available on MY retail branch.
      posLimit: {
        disabled: InvoiceLimitController.invoiceLimitStatusSummary.isFrozen,
        remainingLimit:
          InvoiceLimitController.invoiceLimitStatusSummary.remainingLimit
      }
      */
    };
  }

  get paymentEligibilityChange() {
    return [
      this.paymentEligibility.cod.disabled,
      this.paymentEligibility.dfod.disabled
      // // this.paymentEligibility.posLimit.disabled
    ].join("|");
  }

  // Duplicate STT: eligibility (COD config, destination) masih async saat
  // prefill; flip sementara tidak boleh me-reset COD/DFOD ke CASH.
  isPrefillingPaymentMethod = false;

  checkPaymentMethod() {
    if (this.isPrefillingPaymentMethod) return;
    if (
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.CASH ||
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.INVOICE_LIMIT
    )
      return;

    const field = this.bookingFormV4.paymentMethod.method;
    if (this.paymentEligibility[field].disabled) {
      this.bookingFormV4.paymentMethod.method = PaymentMethodV4.CASH;
    }
  }

  get isPaymentCash() {
    return this.bookingFormV4.paymentMethod.method === PaymentMethodV4.CASH;
  }

  get isPaymentCOD() {
    return this.bookingFormV4.paymentMethod.method === PaymentMethodV4.COD;
  }

  get isPaymentDFOD() {
    return this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD;
  }

  get isPaymentInvoiceLimit() {
    return (
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.INVOICE_LIMIT
    );
  }

  mapPaymentMethodOptions(
    eligibility: PaymentEligibilityV4
  ): PaymentMethodOptionV4[] {
    const options: PaymentMethodOptionV4[] = [
      new PaymentMethodOptionV4({ key: PaymentMethodV4.CASH })
    ];

    options.push(
      new PaymentMethodOptionV4({
        key: PaymentMethodV4.COD,
        disabled: eligibility.cod.disabled,
        hoverCopy: eligibility.cod.disabled ? eligibility.cod.hoverCopy : ""
      }),
      new PaymentMethodOptionV4({
        key: PaymentMethodV4.DFOD,
        disabled: eligibility.dfod.disabled,
        hoverCopy: eligibility.dfod.disabled ? eligibility.dfod.hoverCopy : ""
      })
    );

    // const eligiblePosLimit =
    //   this.accountIsNonForeign &&
    //   InvoiceLimitController.invoiceLimitStatusSummary.status === "active";

    // if (eligiblePosLimit) {
    //   options.push(
    //     new PaymentMethodOptionV4({
    //       key: PaymentMethodV4.INVOICE_LIMIT,
    //       disabled: eligibility.posLimit.disabled,
    //       hoverCopy: eligibility.posLimit.disabled
    //         ? (this.$t("bookingV4.payment.disable.invoiceLimitFrozen") as string)
    //         : "",
    //       remainingLimit: eligibility.posLimit.remainingLimit
    //     })
    //   );
    // }

    return options;
  }

  get paymentMethodOptions(): PaymentMethodOptionV4[] {
    return this.mapPaymentMethodOptions(this.paymentEligibility);
  }

  onPaymentMethodUpdate(payload: PaymentMethodBookingV4): void {
    this.bookingFormV4.paymentMethod = payload;

    this.bookingFormV4.protectionPacking = new ProtectionPackingBookingV4({
      ...this.bookingFormV4.protectionPacking,
      itemPrice: this.bookingFormV4.protectionPacking.itemPrice,
      woodpackingEligible: this.bookingFormV4.protectionPacking
        .woodpackingEligible,
      woodpackingAdditionalWeightKg: this.bookingFormV4.protectionPacking
        .woodpackingAdditionalWeightKg,
      protectionLabel: ""
    });

    if (this.isInsuranceActive) {
      this.onSetInsurance();
    }
    this.validateErrorPrice();
  }

  // --- Proteksi / Packing Kayu derive + parent bind (GENESIS-20160) ---
  // Child 19577 is presentational-only (no derive logic); everything below
  // is parent-owned per the detailing's scope boundary. CW Final apply /
  // StickyFooter is GENESIS-20161 — this subtask stops at the WP weight
  // *preview* and never touches chargeableWeightKg/chargeableWeightExpanded.

  // COD/DFOD "Asuransi YA" config (PRD §3.15.2/§3.15.5) — no ticket in this
  // delta fetches the COD/DFOD configuration API's Asuransi flag into v4
  // (v3's equivalent is CodConfigurationController.getList(), never wired
  // here), and this ticket's own scope explicitly excludes new HTTP.
  // Stubbed inactive — same "hidden until upstream config lands" pattern as
  // ciplDeminimisThreshold/hwsConfigForSelectedProduct above — so the
  // disable/label/commission derive below is structurally wired and
  // activates once a follow-up ticket supplies the real config.
  ccoCodActive = new DetailCodConfigurationRetail();
  ccoDfodActive = new DetailCodConfigurationRetail();

  async getCODConfig() {
    const res = await CodConfigurationController.getList(
      new ApiRequestList({
        page: 1,
        limit: 20
      })
    );

    const codConfig = res.data.find((config: DetailCodConfigurationRetail) => {
      return config.ccoName === "COD Retail";
    }) as DetailCodConfigurationRetail;
    const dfodConfig = res.data.find((config: DetailCodConfigurationRetail) => {
      return config.ccoName === "DFOD Retail";
    }) as DetailCodConfigurationRetail;

    this.ccoCodActive = codConfig;
    this.ccoDfodActive = dfodConfig;
  }

  get isCodInsuranceActive(): boolean {
    const method = this.bookingFormV4.paymentMethod.method;
    return this.ccoCodActive.ccoIsInsurance && method === PaymentMethodV4.COD;
  }

  get isDfodInsuranceActive(): boolean {
    const method = this.bookingFormV4.paymentMethod.method;
    return this.ccoDfodActive.ccoIsInsurance && method === PaymentMethodV4.DFOD;
  }

  get isCodDfodInsuranceActive() {
    return this.isCodInsuranceActive || this.isDfodInsuranceActive;
  }

  get isInsuranceActive(): boolean {
    return (
      this.ccoCodActive.ccoIsInsurance || this.ccoDfodActive.ccoIsInsurance
    );
  }

  // Malaysia RM200 ambang (Business Rules "Default Proteksi per Konteks") —
  // reuses isDestinationForeign (isMalaysiaDistrict on destinationCountryCode),
  // already the SSOT for MY-market checks elsewhere in this file.

  get originCountry() {
    return (
      this.districtDetail?.countryCode ??
      AccountController.accountData.countryCode
    );
  }

  getInsuranceAvailability = debounce(async () => {
    if (!getToken()) return;
    await BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2,
      originCountry: this.originCountry
    }).then(() => {
      this.onSetInsurance();
    });
  }, 500);

  get insuranceBasic() {
    const basic = BookingController.insuranceTypeDelivery.data.find(
      (item: InsuranceTypeDeliveryData) => item.value === "basic"
    );

    return new InsuranceTypeDeliveryData(basic);
  }

  // Config-driven (not MY-hardcoded): protection is configurable whenever the
  // backend exposes an available basic insurance with a start-from threshold.

  get validationGreather5Million(): boolean {
    if (this.accountCountryCode.toUpperCase() !== "ID") return false;
    const itemPrice = this.bookingFormV4.protectionPacking.itemPrice || 0;
    return itemPrice >= 5000000;
  }

  // POS agent discount commission text (PRD §3.15.5) — visibility gating
  // (POS-only, hidden during COD/DFOD Asuransi "YA") is real; the insurance
  // commission %% × item-price tiering config isn't fetched anywhere in
  // this delta (same gap as isCodDfodInsuranceActive above), so the amount
  // stays a stubbed 0 — formatPriceRP/RM are still exercised here so the
  // binding is ready the moment that config lands.
  insuranceData = new Insurance();

  get insurancePayload() {
    return new ApiRequestList({
      isPagination: true,
      typeInsurance: this.bookingFormV4.protectionPacking.insuranceType,
      goodsPrice: this.bookingFormV4.protectionPacking.itemPrice,
      country: AccountController.accountData.countryCode,
      accountType: "pos",
      accountRefId: AccountController.accountData.account_type_detail.id
    });
  }

  getInsuranceConfig = debounce(async () => {
    if (
      !this.bookingFormV4.protectionPacking.itemPrice &&
      this.accountCountryCode.toUpperCase() !== "ID"
    )
      return;
    const resp = await InsuranceController.getInsurance(this.insurancePayload);
    this.insuranceData = resp;
  }, 500);

  get posInsuranceCommissionAmount(): number {
    return this.insuranceData.commisionPos; // TODO: insurance commission % × item-price tiering config
  }

  get agentDiscountCommission(): string | undefined {
    if (
      !this.isPosAccount ||
      this.isCodDfodInsuranceActive ||
      !this.insuranceBasic.isAvailable ||
      !this.isInsuranceMin
    ) {
      return undefined;
    }
    const amount = this.posInsuranceCommissionAmount;
    return this.accountIsNonForeign
      ? formatPriceRP(amount)
      : formatPriceRM(amount);
  }

  // Aggregate GW/VW across all koli (GENESIS-20157 pieces) — WP weight is
  // calculated once per STT, not per piece (PRD §3.16.3).
  get totalGrossWeightKg(): number {
    return this.bookingFormV4.pieces.reduce(
      (sum, piece) => sum + (piece.grossWeight || 0),
      0
    );
  }

  get totalVolumeWeightKg(): number {
    return this.bookingFormV4.pieces.length === 1
      ? this.bookingFormV4?.pieces?.[0]?.volumeWeight || 0
      : this.bookingFormV4.pieces.reduce(
          (sum, piece) =>
            sum + Math.trunc((piece.volumeWeight || 0) * 100) / 100,
          0
        );
  }

  get woodpackingEligibilitySignature(): string {
    const cityCode = this.districtDetail?.cityCode;
    const productType = this.bookingFormV4.product?.productType;
    if (!cityCode || !productType) return "";
    return [cityCode, productType, this.bookingFormV4.receiver?.id].join("|");
  }

  // get woodpackingEligibility(): WoodpackingEligibility {
  //   return BookingController.woodpackingEligibility;
  // }

  get isWoodpackingConfigActive(): boolean {
    return Boolean(this.bookingFormV4.protectionPacking.woodpackingEligible);
  }

  get computedWoodpackingEligible(): boolean {
    return (
      this.isWoodpackingConfigActive && !!this.bookingFormV4.product.productType
    );
  }

  get piecesWeightSignature(): string {
    return this.bookingFormV4.pieces
      .map((piece) => `${piece.grossWeight}:${piece.volumeWeight}`)
      .join(",");
  }

  // Watched signature (see @Options.watch) — only the *inputs* to the
  // derive, never protectionPacking's own output fields, so re-deriving
  // doesn't retrigger itself.
  get protectionDeriveSignature(): string {
    return [
      this.bookingFormV4.protectionPacking.itemPrice,
      this.bookingFormV4.paymentMethod.method,
      this.bookingFormV4.product.productType,
      this.bookingFormV4.receiver.destinationCountryCode,
      this.piecesWeightSignature
    ].join("|");
  }

  // fetchWoodpackingEligibilityDebounced = debounce(async function(this: any) {
  //   const origin3lc = this.districtDetail.cityCode;
  //   const productType = this.bookingFormV4.product?.productType;
  //   const accountRef = this.bookingFormV4.receiver?.id;

  //   const isInvalid = !origin3lc || !productType;

  //   if (isInvalid) {
  //     // this.bookingFormV4.protectionPacking.woodpackingEligible = false;
  //     return;
  //   }

  //   try {
  //     const response = await BookingController.getWoodpackingEligibility(
  //       new WoodpackingEligibilityQuery({
  //         origin3lc: origin3lc,
  //         productType: productType.toUpperCase().trim(),
  //         accountRef: accountRef
  //       })
  //     );

  //     this.bookingFormV4.protectionPacking.woodpackingEligible = response
  //       ? response.eligible
  //       : false;
  //   } catch (error) {
  //     this.bookingFormV4.protectionPacking.woodpackingEligible = false;
  //   } finally {
  //     this.onSetWoodpacking();
  //   }
  // }, 300);

  get isInsuranceMin(): boolean {
    const itemPrice = this.bookingFormV4.protectionPacking.itemPrice || 0;
    return itemPrice > this.insuranceBasic.insuranceBasicStartFrom;
  }

  onSetInsurance(): void {
    const pp = this.bookingFormV4.protectionPacking;
    const greather5Million = this.validationGreather5Million;

    if (this.isPaymentCash || this.isPaymentInvoiceLimit) {
      const allowInsurance = this.isInsuranceMin;
      const disabled = !allowInsurance || greather5Million;

      if (greather5Million) {
        pp.protectionDisabled = true;
        pp.protectionChecked = true;
        pp.insuranceType = "basic";
        pp.protectionLabel = "";
        return;
      }

      if (disabled) {
        if (!allowInsurance) {
          pp.showTresholdProtection = true;
        }

        pp.protectionDisabled = true;
        pp.protectionChecked = false;
        pp.insuranceType = "free";
        pp.protectionLabel = "";
        return;
      }

      const changed = pp.hasChanged;
      const lastChecked = pp.lastChecked;
      const checked = changed ? lastChecked : true;

      pp.protectionChecked = checked;
      pp.insuranceType = checked ? "basic" : "free";
      pp.protectionDisabled = false;
      pp.showTresholdProtection = false;
      pp.protectionLabel = "";
      return;
    }

    if (this.isPaymentCOD) {
      const configActive = this.isCodInsuranceActive;

      if (configActive) {
        pp.protectionLabel = this.$t(
          "bookingV4.protection.alreadyProtected"
        ) as string;
        pp.protectionDisabled = true;
        pp.protectionChecked = false;
        pp.insuranceType = "free";
        return;
      }

      if (greather5Million) {
        pp.protectionDisabled = true;
        pp.protectionChecked = true;
        pp.insuranceType = "basic";
        pp.protectionLabel = "";
        return;
      }

      const changed = pp.hasChanged;
      const lastChecked = pp.lastChecked;
      const checked = changed ? lastChecked : pp.protectionChecked;

      pp.protectionChecked = checked;
      pp.insuranceType = checked ? "basic" : "free";
      pp.protectionDisabled = false;
      pp.protectionLabel = "";
      return;
    }

    if (this.isPaymentDFOD) {
      const configActive = this.isDfodInsuranceActive;

      if (configActive) {
        pp.protectionLabel = this.$t(
          "bookingV4.protection.alreadyProtected"
        ) as string;
        pp.protectionDisabled = true;
        pp.protectionChecked = false;
        pp.insuranceType = "free";
        return;
      }

      if (greather5Million) {
        pp.protectionDisabled = true;
        pp.protectionChecked = true;
        pp.insuranceType = "basic";
        pp.protectionLabel = "";
        return;
      }

      const changed = pp.hasChanged;
      const lastChecked = pp.lastChecked;
      const checked = changed ? lastChecked : pp.protectionChecked;

      pp.protectionChecked = checked;
      pp.insuranceType = checked ? "basic" : "free";
      pp.protectionDisabled = false;
      pp.protectionLabel = "";
      return;
    }
  }

  onSetWoodpacking() {
    const pp = this.bookingFormV4.protectionPacking;

    const eligible = this.computedWoodpackingEligible;
    pp.woodpackingEligible = eligible;
    if (!eligible && pp.woodpacking) {
      pp.woodpacking = false; // auto-uncheck out-of-scope (§3.16.2 AC)
    }
    // GENESIS-20161 — finalize totalKoli/chargeableWeightKg onto
    // protectionPacking.
    pp.totalKoli = this.bookingFormV4.pieces.length;
    pp.chargeableWeightKg = this.chargeableWeightBreakdown.finalCwKg;
  }

  // CW breakdown view DTO (GENESIS-20161, child GENESIS-19578) — GW/VW v3
  // parity (max of the two koli aggregates) plus WP weight when checked.
  // Uses per-product rounding rules from configurationRules (GENESIS-19593)
  // with fallback to rule 0.31 when no product is selected.
  get chargeableWeightBreakdown(): ChargeableWeightBreakdownV4 {
    const pp = this.bookingFormV4.protectionPacking;
    const totalWpWeightKg = pp.woodpacking
      ? pp.woodpackingAdditionalWeightKg
      : 0;
    const chWeight =
      Math.max(this.totalGrossWeightKg, this.totalVolumeWeightKg) +
      totalWpWeightKg;
    const selectedProduct = this.bookingFormV4.product.productType;
    const currentRule = this.configurationRules.find(
      (rule) => rule.product?.toLowerCase() === selectedProduct.toLowerCase()
    );

    if (!selectedProduct) {
      const finalCwKg = getRoundedChargeableWeightByRules({
        chargeableWeight: chWeight,
        productType: "",
        rule: 0.31
      });
      return new ChargeableWeightBreakdownV4({
        totalGrossWeightKg: this.totalGrossWeightKg,
        totalVolumeWeightKg: this.totalVolumeWeightKg,
        totalWpWeightKg,
        finalCwKg
      });
    }

    const isEligible = isEligibleForMaxVolumeWeightDiscount({
      productType: selectedProduct,
      volumeWeight: this.totalVolumeWeightKg
    });
    const baseWeight =
      isEligible || selectedProduct.toUpperCase() === "INTERPACKMAXI"
        ? this.totalGrossWeightKg
        : Math.max(this.totalGrossWeightKg, this.totalVolumeWeightKg);

    const finalCwKg = getRoundedChargeableWeightByRules({
      chargeableWeight: baseWeight + totalWpWeightKg,
      productType: selectedProduct.toUpperCase(),
      rule: Number(currentRule?.parameter) || 0.31,
      ruleKey: currentRule?.ruleKey
    });

    return new ChargeableWeightBreakdownV4({
      totalGrossWeightKg: this.totalGrossWeightKg,
      totalVolumeWeightKg: this.totalVolumeWeightKg,
      totalWpWeightKg,
      finalCwKg
    });
  }

  // @update:protectionPacking from 19577 — assign the (already-immutable-
  // copied) entity then re-run derive. Mirrors onProtectionPackingUpdateFromCwFooter
  // (GENESIS-20161), which owns only chargeableWeightExpanded — don't merge
  // the two handlers (per detailing's explicit handler-split note).

  mapErrorCodDfod(value: number) {
    return this.accountIsNonForeign
      ? formatPriceRP(value)
      : formatPriceRM(value);
  }

  get minMaxConfig() {
    const config = FlagsPermissionBookingV3.config_min_max_goods_price.getValue();
    const range = config["retail"];
    return { min: range.min, max: range.max };
  }

  validateErrorPrice() {
    const itemPrice = this.bookingFormV4.protectionPacking.itemPrice;
    if (itemPrice === null) {
      this.errors.itemPrice = this.$t(
        "bookingV4.protection.itemPrice.error"
      ) as string;
      return;
    }

    if (
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.COD ||
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD
    ) {
      const ccoConfig =
        this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD
          ? this.ccoDfodActive
          : this.ccoCodActive;
      const isBelowMin = itemPrice < ccoConfig.ccoMinPrice;
      const isAboveMax = itemPrice > ccoConfig.ccoMaxPrice;
      this.errors.itemPrice = isBelowMin
        ? (this.$t("bookingV4.protection.itemPrice.errorMin", {
            value: this.mapErrorCodDfod(ccoConfig.ccoMinPrice)
          }) as string)
        : isAboveMax
        ? (this.$t("bookingV4.protection.itemPrice.errorMax", {
            value: this.mapErrorCodDfod(ccoConfig.ccoMaxPrice)
          }) as string)
        : "";
      return;
    }

    const { min, max } = this.minMaxConfig;
    const isBelowMin = itemPrice < min;
    const isAboveMax = itemPrice > max;
    this.errors.itemPrice = isBelowMin
      ? (this.$t("bookingV4.protection.itemPrice.errorMin", {
          value: this.mapErrorCodDfod(min)
        }) as string)
      : isAboveMax
      ? (this.$t("bookingV4.protection.itemPrice.errorMax", {
          value: this.mapErrorCodDfod(max)
        }) as string)
      : "";
  }

  onProtectionPackingUpdate(value: ProtectionPackingBookingV4): void {
    this.bookingFormV4.protectionPacking = value;

    if (this.bookingFormV4.protectionPacking.itemPrice) {
      this.getInsuranceConfig();
    }

    this.validateErrorPrice();
  }

  onUpdatePrice(): void {
    this.getInsuranceConfig();

    this.onSetInsurance();

    this.validateErrorPrice();
  }

  onItemPriceBlur(): void {
    this.validateErrorPrice();
  }

  // CW footer (GENESIS-19578) emit — the child only carries chargeableWeightKg/
  // totalKoli/chargeableWeightExpanded/woodpacking (see its emitProtectionPacking),
  // not the full entity, so only chargeableWeightExpanded is safe to copy back;
  // assigning the whole value would clobber protectionChecked/itemPrice/etc.
  // back to class defaults. Expand toggle only — no re-derive (per detailing's
  // explicit handler-split note).
  onProtectionPackingUpdateFromCwFooter(
    value: ProtectionPackingBookingV4
  ): void {
    this.bookingFormV4.protectionPacking.chargeableWeightExpanded =
      value.chargeableWeightExpanded;
  }

  // --- Product upselling context signature (GENESIS-20159) ---
  // Same guard fields as estimation price: origin/destination/commodity/tab.
  get productUpsellingContextSignature(): string {
    return JSON.stringify(this.upsellingPayload);
  }

  get upsellingPayload() {
    const destination = this.destinationCityDetail;
    const protectionPacking = this.bookingFormV4.protectionPacking;
    const paymentMethod = this.bookingFormV4.paymentMethod;
    const goodsPrice = protectionPacking.itemPrice || 0;
    const isCodOrDfod = [
      PaymentMethodV4.COD.toString(),
      PaymentMethodV4.DFOD.toString()
    ].includes(paymentMethod.method);
    const codAmount = Math.max(
      isCodOrDfod ? 1 : 0,
      paymentMethod.codAmount || goodsPrice
    );
    return new PayloadPosterProduct({
      originId: this.districtDetail.code,
      destinationId: destination?.code || "",
      accountType: "pos",
      accountRefId: 0,
      commodityId: this.bookingFormV4.commodity.id || 499,
      commodity: {
        data: new ComodityProductPoster({
          commodityId: this.bookingFormV4.commodity.id,
          commodityCode: this.bookingFormV4.commodity.code,
          commodityName: this.bookingFormV4.commodity.name
        })
      },
      productType: "",
      goodsPrice: goodsPrice,
      codAmount: codAmount,
      isCod: isCodOrDfod,
      isDfod: this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD,
      isPad: false,
      insuranceType: this.bookingFormV4.protectionPacking.insuranceType,
      isWoodpacking: this.bookingFormV4.protectionPacking.woodpacking,
      isHaveTaxId: !!this.bookingFormV4.supportingDoc.ftzForm.taxNumber,
      pieces: this.bookingFormV4.pieces.map((piece) => ({
        pieceLength: piece.length || (this.isCipl ? 3 : 0),
        pieceWidth: piece.width || (this.isCipl ? 20 : 0),
        pieceHeight: piece.height || (this.isCipl ? 10 : 0),
        pieceGrossWeight: piece.grossWeight
      })),
      promoAppliedTo: "",
      isDisablePromo: false,
      isBookingPuposes: false,
      shipmentPrefix: ""
    });
  }

  fetchProductUpsellingDebounced = debounce(() => {
    this.fetchProductUpselling();
  }, 500);

  // --- Tariff estimation wiring (GENESIS-19591) ---
  // Mirrors create-booking-v3/create-booking-manual.vue's
  // estimationPriceContextPayload/estimationPricePayload split: the context
  // payload excludes voucherCode so the deep watcher below doesn't need a
  // separate voucher-only watcher (GENESIS-19592's appliedVoucherCode is
  // read via estimationPricePayload right below, not part of the deep
  // watcher target, so a voucher-only change won't re-trigger estimation
  // on its own — GENESIS-19592 is expected to call getEstimationPrice()
  // directly after a successful apply/remove, same as V3's onVoucherContextChanged).
  get normalizedSenderPhone(): string {
    const sender = this.bookingFormV4.sender;
    return `${sender.phone ? sender.phoneCode : ""}${sender.phone}`.replace(
      /\+/g,
      ""
    );
  }

  get estimationPriceContextPayload(): GetEstimationPriceV4 {
    const protectionPacking = this.bookingFormV4.protectionPacking;
    const paymentMethod = this.bookingFormV4.paymentMethod;
    const goodsPrice = protectionPacking.itemPrice || 0;

    const isCodOrDfod = [
      PaymentMethodV4.COD.toString(),
      PaymentMethodV4.DFOD.toString()
    ].includes(paymentMethod.method);

    return new GetEstimationPriceV4({
      originId: this.districtDetail.code,
      destinationId: this.destinationCityDetail?.code || "",
      commodityId: this.bookingFormV4.commodity.id,
      productType: this.bookingFormV4.product.productType,
      accountType: "pos",
      accountRefId: AccountController.accountData.account_type_detail.id,
      goodsPrice,
      insuranceType: protectionPacking.insuranceType,
      isWoodpacking: protectionPacking.woodpacking,
      isHaveTaxId:
        this.isFtzForm && !!this.bookingFormV4.supportingDoc.ftzForm.taxNumber,
      pieces: this.bookingFormV4.pieces.map((piece) => ({
        pieceLength: piece.length,
        pieceWidth: piece.width,
        pieceHeight: piece.height,
        pieceGrossWeight: piece.grossWeight
      })) as any,
      // Limit Tagihan has no dedicated payload field — it doesn't affect
      // tariff calculation (Jira note on this ticket's Technical Steps §2).
      isCod: isCodOrDfod,
      isDfod: paymentMethod.method === PaymentMethodV4.DFOD,
      codHandling: "",
      codAmount: goodsPrice,
      isDisablePromo: false,
      promoAppliedTo: "retail",
      isPad: false,
      shipmentPrefix: "",
      hideError: false,
      senderPhone: this.normalizedSenderPhone
    });
  }

  get estimationPricePayload(): GetEstimationPriceV4 {
    return new GetEstimationPriceV4({
      ...this.estimationPriceContextPayload
      // voucherCode: this.bookingFormV4.voucher.appliedVoucherCode
    });
  }

  get isTariffContextReady(): boolean {
    const hasCompletePieces =
      this.bookingFormV4.pieces.length > 0 &&
      this.bookingFormV4.pieces.every(
        (piece) =>
          piece.grossWeight > 0 &&
          piece.length > 0 &&
          piece.width > 0 &&
          piece.height > 0
      );
    return !!(
      this.districtDetail.code &&
      this.destinationCityDetail?.code &&
      this.bookingFormV4.commodity.id &&
      this.bookingFormV4.product.productType &&
      hasCompletePieces
    );
  }

  get footerChargeableWeightKg(): number {
    return this.bookingFormV4.estimationPrice.chargeableWeight;
  }

  resetEstimationPrice(): void {
    this.estimationRequestId += 1;
    this.bookingFormV4.estimationPrice = new EstimationPrice();
    this.bookingFormV4.protectionPacking.woodpackingAdditionalWeightKg = 0;
    this.estimationLoading = false;
    this.estimationIsError = false;
  }

  async getEstimationPrice(): Promise<void> {
    if (!this.isTariffContextReady) {
      this.resetEstimationPrice();
      return;
    }
    const requestId = ++this.estimationRequestId;
    try {
      this.estimationLoading = true;
      this.estimationIsError = false;
      if (this.productUpsellingLoading) {
        this.fetchPromisesAfterGetUpselling.push("getEstimationPriceDebounced");
        return;
      }
      const estimationPrice = await BookingV4Controller.getEstimationPrice(
        this.estimationPricePayload
      );
      if (requestId !== this.estimationRequestId) return;
      this.bookingFormV4.estimationPrice = estimationPrice;
      // this.bookingFormV4.protectionPacking.woodpackingAdditionalWeightKg =
      //   estimationPrice.woodpackingAdditionalWeight;
    } catch (error) {
      if (requestId !== this.estimationRequestId) return;
      this.estimationIsError = true;
    } finally {
      if (requestId === this.estimationRequestId) {
        this.estimationLoading = false;
      }
    }
  }

  // Debounced trigger — the deep `estimationPriceContextPayload` watcher
  // (see @Options) calls this on every field change that affects tariff.
  getEstimationPriceDebounced = debounce(() => {
    if (this.productUpsellingLoading)
      return this.fetchPromisesAfterGetUpselling.push(
        "getEstimationPriceDebounced"
      );
    this.getEstimationPrice();
  }, 500);

  // Parent bind target for TotalTarifSectionV4's `@refresh` (GENESIS-20108)
  // once it mounts via GENESIS-20161's StickyFooter wrapper — re-invokes
  // getEstimationPrice immediately (no debounce) same as V3's `@refresh`.
  onTariffRefresh(): void {
    this.getEstimationPrice();
  }
  /* Voucher temporarily disabled on MY retail branch
  get isVoucherFeatureEnabled() {
    return FlagsPermissionBookingV3.config_show_voucher_booking.isEnabled();
  }

  // --- Voucher / OTP orchestration (GENESIS-19592) ---
  // canLoad / isVoucherContextReady §3.13.2 — same "form complete enough to
  // price" guard as getEstimationPriceDebounced(), owned by this subtask
  // (not FormCompletion/GENESIS-19583).
  get isVoucherContextReady(): boolean {
    return !!(
      this.isVoucherFeatureEnabled &&
      this.isAllSectionValid &&
      this.districtDetail.id &&
      this.destinationCityDetail?.id &&
      this.bookingFormV4.commodity.id &&
      this.bookingFormV4.product.productType
    );
  }

  get voucherHasMore(): boolean {
    return this.voucherPagination.hasMore;
  }

  get canSubmitVoucherManualCode(): boolean {
    const code = this.voucherManualCode ?? "";
    if (!code) return false;
    if (/\s/.test(code)) return false;
    return /^[A-Z0-9]+$/.test(code);
  }

  get showVoucherOtpBanner(): boolean {
    return (
      !!this.bookingFormV4.voucher.appliedVoucherCode &&
      this.appliedVoucherItem.isOtpRequired &&
      FlagsPermissionBookingV3.config_validate_otp_voucher_hq.isEnabled()
    );
  }

  // Excludes `voucherCode` (declared on GetEstimationPriceV4 but not part of
  // the list/validate request contracts) so it doesn't leak into their JSON
  // body as an undeclared field.
  get voucherPayloadBase(): Omit<
    GetEstimationPriceV4,
    "voucherCode" | "toJSON"
  > {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { voucherCode, ...base } = this.estimationPriceContextPayload;
    return base;
  }

  buildVoucherListPayload(cursor = ""): GetBookingVoucherListV4 {
    return new GetBookingVoucherListV4({
      ...this.voucherPayloadBase,
      senderPhone: this.normalizedSenderPhone,
      cursor,
      limit: 20
    });
  }

  buildVoucherValidatePayload(
    voucherCode: string
  ): ValidateBookingVoucherCodeV4 {
    return new ValidateBookingVoucherCodeV4({
      ...this.voucherPayloadBase,
      voucherCode: voucherCode,
      senderPhone: this.normalizedSenderPhone
    });
  }

  async fetchVoucherList(cursor = "", shouldAppend = false): Promise<boolean> {
    if (!this.isVoucherContextReady) return false;
    const requestContext = JSON.stringify(this.estimationPriceContextPayload);

    try {
      this.loadingVoucherList = true;
      const resp = (await BookingV4Controller.getBookingVoucherList(
        this.buildVoucherListPayload(cursor)
      )) as BookingVoucherList;
      if (
        !this.isVoucherContextReady ||
        requestContext !== JSON.stringify(this.estimationPriceContextPayload)
      ) {
        return false;
      }

      this.voucherItems = shouldAppend
        ? [...this.voucherItems, ...resp.data]
        : resp.data;
      this.voucherPagination = resp.pagination;
      return true;
    } catch {
      if (
        this.isVoucherContextReady &&
        requestContext === JSON.stringify(this.estimationPriceContextPayload) &&
        !shouldAppend
      ) {
        this.voucherItems = [];
        this.voucherPagination = new BookingVoucherPagination();
      }
      return false;
    } finally {
      this.loadingVoucherList = false;
    }
  }

  async loadMoreVoucherList(): Promise<void> {
    if (!this.voucherPagination.hasMore || this.loadingVoucherList) return;
    await this.fetchVoucherList(this.voucherPagination.nextCursor, true);
  }

  // §3.13.5 — Lihat Lebih Banyak: fetch-all cursor loop until !hasMore, so
  // the child renders the full eligible/disabled list vertically.
  async onToggleSeeMoreVoucher(): Promise<void> {
    this.isSeeMoreExpanded = !this.isSeeMoreExpanded;
    if (!this.isSeeMoreExpanded) return;

    const visitedCursors = new Set<string>();
    while (this.isVoucherContextReady && this.voucherPagination.hasMore) {
      const cursor = this.voucherPagination.nextCursor;
      if (!cursor || visitedCursors.has(cursor)) break;
      visitedCursors.add(cursor);
      const isSuccess = await this.fetchVoucherList(cursor, true);
      if (!isSuccess || this.voucherPagination.nextCursor === cursor) break;
    }
  }

  closeVoucherTerms(): void {
    this.voucherTermsVoucher = new BookingVoucherItem();
  }

  openVoucherTerms(voucher: BookingVoucherItem): void {
    this.voucherTermsVoucher = new BookingVoucherItem(voucher);
  }

  async onChangeVoucherManualCode(value: string): Promise<void> {
    this.voucherManualCode = value.trim().toUpperCase();
    this.voucherManualError = "";

    if (
      !this.voucherManualCode &&
      this.bookingFormV4.voucher.appliedVoucherCode
    ) {
      this.clearAppliedVoucher();
      this.resetOtpVoucherState();
      await this.getEstimationPrice();
    }
  }

  getVoucherApiErrorMessage(error: any, fallback: string): string {
    const message = error?.response?.data?.message;
    if (typeof message === "string") return message || fallback;
    const locale = this.$i18n.locale === "id" ? "id" : "en";
    return message?.[locale] || message?.id || message?.en || fallback;
  }

  resetOtpVoucherState(): void {
    this.isOtpVoucherModalVisible = false;
    this.loadingIssueOtpVoucher = false;
    this.loadingVerifyOtpVoucher = false;
    this.otpVoucherErrorMessage = "";
    this.otpVoucherExpiresAt = "";
    this.bookingFormV4.voucher.otpToken = "";
    this.bookingFormV4.voucher.otpCode = "";
    this.bookingFormV4.voucher.goberReservationId = "";
  }

  // Persist the applied voucher's submission fields onto bookingFormV4.voucher
  // and mirror the full item locally for display (isOtpRequired, discount...).
  setAppliedVoucher(voucher: BookingVoucherItem): void {
    this.appliedVoucherItem = new BookingVoucherItem(voucher);
    this.voucherManualCode = voucher.voucherCode;
    this.bookingFormV4.voucher.appliedVoucherCode = voucher.voucherCode;
    this.bookingFormV4.voucher.appliedVoucherId =
      Number(voucher.voucherId) || 0;
    this.bookingFormV4.voucher.appliedVoucherCodeId = voucher.voucherCodeId;
  }

  isVoucherApplied(voucher: BookingVoucherItem): boolean {
    const appliedVoucher = this.bookingFormV4.voucher;
    return (
      !!voucher.voucherCode &&
      appliedVoucher.appliedVoucherCode === voucher.voucherCode &&
      appliedVoucher.appliedVoucherId === Number(voucher.voucherId) &&
      appliedVoucher.appliedVoucherCodeId === voucher.voucherCodeId
    );
  }

  clearAppliedVoucher(): void {
    this.appliedVoucherItem = new BookingVoucherItem();
    this.voucherManualCode = "";
    this.bookingFormV4.voucher.appliedVoucherCode = "";
    this.bookingFormV4.voucher.appliedVoucherId = 0;
    this.bookingFormV4.voucher.appliedVoucherCodeId = 0;
  }

  clearVoucherContextState(): void {
    this.voucherPagination = new BookingVoucherPagination();
    this.voucherItems = [];
    this.voucherManualError = "";
    this.voucherManualCode = "";
    this.closeVoucherTerms();
    this.clearAppliedVoucher();
    this.resetOtpVoucherState();
    this.isSeeMoreExpanded = false;
  }

  async applyVoucherFromList(voucher: BookingVoucherItem): Promise<void> {
    if (!voucher.isEligible) return;

    if (this.isVoucherApplied(voucher)) {
      this.clearAppliedVoucher();
    } else {
      this.setAppliedVoucher(voucher);
    }
    this.resetOtpVoucherState();
    this.voucherManualError = "";
    this.closeVoucherTerms();
    await this.getEstimationPrice();
  }

  async submitVoucherManualCode(): Promise<void> {
    if (!this.canSubmitVoucherManualCode) return;

    try {
      this.loadingVoucherManual = true;
      this.voucherManualError = "";
      const voucher = (await BookingV4Controller.validateBookingVoucherCode(
        this.buildVoucherValidatePayload(this.voucherManualCode)
      )) as BookingVoucherItem;

      if (!voucher.isEligible) {
        this.voucherManualError = voucher.ineligibleReason || "";
        return;
      }

      this.setAppliedVoucher(
        new BookingVoucherItem({
          ...voucher,
          voucherCode: this.voucherManualCode
        })
      );
      this.resetOtpVoucherState();
      this.closeVoucherTerms();
      await this.getEstimationPrice();
      this.voucherManualCode = "";
    } catch (error) {
      this.voucherManualError = this.getVoucherApiErrorMessage(
        error,
        "Kode voucher tidak valid"
      );
    } finally {
      this.loadingVoucherManual = false;
    }
  }

  // Continue tanpa voucher (OTP sudah di-reserve) → cancel reservasi lalu
  // bersihkan state; tidak re-submit booking di sini (bukan owned subtask ini).
  async onContinueWithoutVoucherOtp(): Promise<void> {
    const voucher = this.bookingFormV4.voucher;
    if (
      this.appliedVoucherItem.voucherCode &&
      voucher.otpToken &&
      voucher.goberReservationId
    ) {
      await BookingV4Controller.cancelVoucherBookingReserve(
        new CancelVoucherBookingReserveRequestV4({
          voucherCode: this.appliedVoucherItem.voucherCode,
          senderPhone: this.normalizedSenderPhone,
          otpToken: voucher.otpToken,
          goberReservationId: Number(voucher.goberReservationId) || 0
        })
      );
    }

    this.clearAppliedVoucher();
    this.resetOtpVoucherState();
    await this.getEstimationPrice();
    this.onSubmit();
  }

  async issueOtpVoucherIfNeeded(keepModalOpenOnError = false): Promise<void> {
    const voucher = this.appliedVoucherItem;
    if (!voucher.voucherCode || !voucher.isOtpRequired) return;
    if (!FlagsPermissionBookingV3.config_validate_otp_voucher_hq.isEnabled()) {
      return;
    }
    try {
      this.loadingIssueOtpVoucher = true;
      this.otpVoucherErrorMessage = "";

      const resp = await BookingV4Controller.issueVoucherBookingOtp(
        new IssueVoucherBookingOtpRequestV4({
          voucherCode: voucher.voucherCode,
          senderPhone: this.normalizedSenderPhone,
          bookingAttemptId: this.bookingFormV4.voucher.bookingAttemptId,
          voucherId: voucher.voucherId,
          voucherCodeId: voucher.voucherCodeId
        })
      );

      if (!resp?.otpToken) {
        this.otpVoucherErrorMessage = "Gagal issue OTP voucher";
        this.isOtpVoucherModalVisible = keepModalOpenOnError;
        return;
      }

      this.bookingFormV4.voucher.otpToken = resp.otpToken;
      this.otpVoucherExpiresAt = resp.expiresAt;
      this.bookingFormV4.voucher.goberReservationId = String(
        resp.goberReservationId
      );
      this.isOtpVoucherModalVisible = true;
    } catch (error) {
      const err: any = error;
      this.otpVoucherErrorMessage = this.getVoucherApiErrorMessage(
        err,
        "Gagal issue OTP voucher"
      );
      this.isOtpVoucherModalVisible = keepModalOpenOnError;
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal issue OTP voucher!", () =>
          MainAppController.closeErrorMessage()
        )
      );
    } finally {
      this.loadingIssueOtpVoucher = false;
    }
  }

  async onResendOtpVoucher(): Promise<void> {
    this.bookingFormV4.voucher.otpToken = "";
    this.bookingFormV4.voucher.goberReservationId = "";
    await this.issueOtpVoucherIfNeeded(true);
  }

  // Verifikasi OTP terjadi implisit saat submit (bukan endpoint terpisah) —
  // simpan kode yang diketik pengguna; isVoucherSubmitReady lolos begitu
  // otpCode/otpToken/goberReservationId lengkap, lalu onSubmit() melanjutkan.
  async onVerifyOtpVoucher(otpCode: string): Promise<void> {
    this.bookingFormV4.voucher.otpCode = otpCode;
    this.otpVoucherErrorMessage = "";
    this.isOtpVoucherModalVisible = false;

    await this.onSubmit();
  }

  // Form context (origin/destination/commodity/product) changed — any
  // fetched voucher list / applied voucher was validated against the old
  // context, so reset it and refetch when the context is ready.
  onVoucherContextChangedDebounced = debounce(async () => {
    this.clearVoucherContextState();

    if (this.isVoucherContextReady) {
      await this.fetchVoucherList();
    }
  }, 300);
  */

  assembleSubmitPayload(): ManualBookingV4Retail {
    const form = this.bookingFormV4;
    const { sender, receiver, commodity, supportingDoc } = form;
    // const voucher = form.voucher;
    const activeDoc = this.isFtzForm
      ? supportingDoc.ftzForm
      : supportingDoc.docInternational;
    const origin = this.districtDetail;
    const destination = receiver.destinationCity;
    const originCity = origin.cityCode || "";
    const originDistrict = origin.code || "";
    const destinationCity =
      typeof destination === "string"
        ? destination
        : destination?.cityCode || "";
    const destinationDistrict =
      typeof destination === "string" ? destination : destination?.code || "";
    const postalCode =
      typeof receiver.postalCode === "string"
        ? receiver.postalCode
        : receiver.postalCode?.destinationZipCode ||
          receiver.postalCode?.name ||
          "";
    const totalGrossWeight = form.pieces.reduce(
      (total, piece) => total + Number(piece.grossWeight || 0),
      0
    );
    const totalVolumeWeight = form.pieces.reduce(
      (total, piece) => total + Number(piece.volumeWeight || 0),
      0
    );
    const normalizePhone = (phoneCode: string, phone: string): string => {
      const value = String(phone || "").replace(/^\+?0+/, "");
      const prefix = phoneCode || "+62";
      const normalizedPrefix = prefix.replace(/^\+/, "");
      const normalizedValue = value.replace(/^\+/, "");
      return normalizedValue.startsWith(normalizedPrefix)
        ? `+${normalizedValue}`
        : `+${normalizedPrefix}${normalizedValue}`;
    };
    const sttPieces = form.pieces.map((piece) => ({
      // eslint-disable-next-line @typescript-eslint/camelcase
      stt_piece_length: piece.length,
      // eslint-disable-next-line @typescript-eslint/camelcase
      stt_piece_width: piece.width,
      // eslint-disable-next-line @typescript-eslint/camelcase
      stt_piece_height: piece.height,
      // eslint-disable-next-line @typescript-eslint/camelcase
      stt_piece_gross_weight: piece.grossWeight,
      // eslint-disable-next-line @typescript-eslint/camelcase
      stt_piece_volume_weight: piece.volumeWeight
    }));
    const parseCiplNumber = (value: unknown): number => {
      const normalized = String(value || "").replace(/[.]/g, "");
      return Number(normalized.replace(",", ".")) || 0;
    };
    const mapCipl = (items: any[]): CIPLTypeV4[] =>
      items
        .filter((item) => item.name)
        .map((item) => ({
          quantity: parseCiplNumber(item.quantity),
          itemPrice: parseByCountry(item.goodsPrice, {
            country: this.accountCountryCode.toUpperCase()
          }),
          itemDetail: item.commodity?.nameId || item.name || "",
          itemDetailEn: item.commodity?.nameEn || item.name || "",
          commodityHsCode: item.commodity?.hsCode || item.hsCode || ""
        }));
    const sttCipl = this.isFtzForm ? [] : mapCipl(form.commodityCipl);
    const ftzCipl = this.isFtzForm ? mapCipl(form.commodityCipl) : [];
    const internationalDoc = supportingDoc.docInternational;
    const ftzDoc = supportingDoc.ftzForm;

    return new ManualBookingV4Retail({
      ...ManualBookingV4Retail.fromReferenceChips(form.references),
      bookingFormVersion: "v4",
      productName: form.product.productType,
      originCity,
      originDistrict,
      destinationCity,
      destinationDistrict,
      phoneSender: normalizePhone(sender.phoneCode, sender.phone),
      phoneReceiver: normalizePhone(receiver.phoneCode, receiver.phone),
      sender: sender.name,
      receiver: receiver.name,
      addressSender: sender.address,
      addressReceiver: receiver.address,
      addressReceiverType: receiver.addressType?.value || "",
      sttGrossWeight: totalGrossWeight,
      sttVolumeWeight: totalVolumeWeight,
      sttChargeableWeight: Math.max(totalGrossWeight, totalVolumeWeight),
      commodityCode: commodity.code,
      insurance: form.protectionPacking.insuranceType,
      estimationPrice: Number(form.protectionPacking.itemPrice || 0),
      taxNumber: ftzDoc.taxNumber,
      statusGoods: ftzDoc.shipmentStatus?.value || "",
      isWoodpack: form.protectionPacking.woodpacking,
      isCOD:
        form.paymentMethod.method === PaymentMethodV4.COD ||
        form.paymentMethod.method === PaymentMethodV4.DFOD,
      isDFOD: form.paymentMethod.method === PaymentMethodV4.DFOD,
      sttCodAmount: Number(form.protectionPacking.itemPrice || 0),
      sttCommodityDetail: "",
      isSaveSender: true,
      isSaveReceiver: true,
      saveCustomerRecipient: true,
      saveCustomerSender: true,
      sttPieces,
      postalCodeDestination: postalCode.split(",")[0].trim(),
      sttRecipientEmail: internationalDoc.email,
      sttKtpImage: this.getSupportingDocUrl(internationalDoc.imageIdUrl),
      sttTaxImage: this.getSupportingDocUrl(internationalDoc.imageTaxUrl),
      sttIdentityNumber: internationalDoc.idNumber,
      sttInterTaxNumber: internationalDoc.taxNumber,
      sttAttachFiles: this.getSupportingDocUrls(
        internationalDoc,
        !this.isFtzForm
      ),
      sttCipl,
      sttFtzRecipientEmail: ftzDoc.email,
      sttFtzIdentityNumber: ftzDoc.idNumber,
      sttFtzKtpImage: this.getSupportingDocUrl(ftzDoc.imageIdUrl),
      sttFtzTaxImage: this.getSupportingDocUrl(ftzDoc.imageTaxUrl),
      sttFtzAttachFiles: this.getSupportingDocUrls(ftzDoc, this.isFtzForm),
      sttFtzCipl: ftzCipl,
      sttPaymentMethod: this.mappedPaymentMethodPayload,
      sttDutyTaxTerms: activeDoc.dutyTaxTerms || "",
      // voucherId: String(voucher.appliedVoucherId || ""),
      // voucherCodeId: voucher.appliedVoucherCodeId,
      // voucherCode: voucher.appliedVoucherCode,
      // goberReservationId: Number(voucher.goberReservationId) || 0,
      // otpToken: voucher.otpToken,
      // otpCode: voucher.otpCode
      savePackage: this.savePackage,
      savedPackage: this.savePackage
        ? {
            // eslint-disable-next-line @typescript-eslint/camelcase
            commodity_code: commodity.code,
            pieces: form.pieces.map((p) => ({
              // eslint-disable-next-line @typescript-eslint/camelcase
              gross_weight: Number(p.grossWeight) || 0,
              length: Number(p.length) || 0,
              width: Number(p.width) || 0,
              height: Number(p.height) || 0
            }))
          }
        : null,
      activeSavedPackageId: this.activeSavedPackageId,
      // eslint-disable-next-line @typescript-eslint/camelcase
      is_selected_saved_package_without_id:
        !this.activeSavedPackageId && this.savePackage
    });
  }

  get mappedPaymentMethodPayload() {
    const paymentMethod = this.bookingFormV4.paymentMethod;
    if (paymentMethod.method === PaymentMethodV4.COD) return "cash";
    if (paymentMethod.method === PaymentMethodV4.DFOD) return "cash";
    if (paymentMethod.method === PaymentMethodV4.INVOICE_LIMIT)
      return "pos_limit";
    return "cash";
  }

  getSupportingDocUrls(
    document: DocInternationalBookingV4,
    includeAdditionalDocuments: boolean
  ): string[] {
    const additionalUrls = includeAdditionalDocuments
      ? this.bookingFormV4.supportingDoc.additionalDocuments.map(
          (item) => item.url
        )
      : [];
    const urls: unknown[] = [
      document.imageBeforePackingUrl,
      document.imageAfterPackingUrl,
      ...additionalUrls
    ];
    return urls.map((url) => this.getSupportingDocUrl(url)).filter(Boolean);
  }

  getSupportingDocUrl(value: unknown): string {
    if (typeof value !== "string" || value.startsWith("blob:")) return "";
    return value;
  }

  triggerSenderRequiredErrors(): void {
    if (!this.bookingFormV4.sender.name) {
      this.errors.sender = "bookingV4.sender.name.error.required";
    }
    if (!this.bookingFormV4.sender.phone) {
      this.errors.phoneSender = "bookingV4.sender.phone.error.required";
    }
    if (!this.bookingFormV4.sender.address) {
      this.errors.addressSender = "bookingV4.sender.address.error.required";
    }
  }

  triggerReceiverRequiredErrors(): void {
    const isInternational =
      this.bookingFormV4.pageMeta.activeTab === "international";
    const isDestinationCountryEmpty =
      isInternational && !this.bookingFormV4.receiver.destinationCountryCode;

    if (!this.bookingFormV4.receiver.name) {
      this.errors.receiver = "bookingV4.recipient.name.error.required";
    }
    if (!this.bookingFormV4.receiver.phone) {
      this.errors.phoneReceiver = "bookingV4.recipient.phone.error.required";
    }
    if (!this.bookingFormV4.receiver.address) {
      this.errors.addressReceiver =
        "bookingV4.recipient.address.error.required";
    }
    if (isDestinationCountryEmpty) {
      this.errors.destinationCountry =
        "bookingV4.recipient.country.error.required";
      this.errors.destinationCity =
        "bookingV4.recipient.city.error.requiredInternational";
      this.errors.postalCode = "bookingV4.recipient.postalCode.error.required";
      return;
    }
    if (!this.bookingFormV4.receiver.destinationCity) {
      this.errors.destinationCity = isInternational
        ? "bookingV4.recipient.city.error.requiredInternational"
        : "bookingV4.recipient.city.error.required";
    }
    if (!this.bookingFormV4.receiver.postalCode) {
      this.errors.postalCode = "bookingV4.recipient.postalCode.error.required";
    }
  }

  triggerGoodsPackageErrors(): void {
    const commodity = this.bookingFormV4.commodity;
    const isCommodityEmpty = !commodity || !commodity.code || !commodity.name;

    if (isCommodityEmpty) {
      this.errors.commodity = "bookingV4.goods.commodity.errorRequired";
    }

    if (this.bookingFormV4.pieces && this.bookingFormV4.pieces.length) {
      this.bookingFormV4.pieces.forEach((piece) => {
        if (!piece.grossWeight || piece.grossWeight <= 0) {
          piece.error.errorMandatoryGrossWeight = true;
        }
        if (!piece.length || !piece.width || !piece.height) {
          piece.error.errorMandatoryVolumeWeight = true;
        }
      });
    }

    this.$nextTick(() => {
      const goodsPackage = this.$refs.goodsPackageRef as any;
      if (
        goodsPackage &&
        typeof goodsPackage.touchAllItemDetailsRows === "function"
      ) {
        goodsPackage.touchAllItemDetailsRows();
      }
    });
  }

  triggerAllFormErrors(): void {
    if (!this.isSenderSectionValid) {
      this.triggerSenderRequiredErrors();
    }
    if (!this.isReceiverSectionValid) {
      this.triggerReceiverRequiredErrors();
    }
    this.triggerGoodsPackageErrors();
    this.validateErrorPrice();
  }

  get isSuccessCreateInvoice() {
    return PrintReceiptController.isSuccessCreateInvoice;
  }
  get successCreateInvoiceData() {
    return PrintReceiptController.successCreateInvoiceData;
  }
  get invoiceDetail() {
    return PrintReceiptController.invoiceDetailData;
  }

  onCloseSuccessCreateInvoice() {
    PrintReceiptController.resetCreateInvoiceFromSuccessBooking();
    PrintReceiptController.setSuccessCreateInvoiceData();
    PrintReceiptController.setInvoiceDetailData();
  }
  async handleDownloadCreateInvoice(option: { key: string }) {
    // Options: 'pdf_a4', 'png_a4', 'struk'
    try {
      MainAppController.showLoading();
      const detail = await PrintReceiptController.getDetailInvoice(
        PrintReceiptController.invoiceDetailData.header.invoiceId
      );
      PrintReceiptController.setInvoiceDetailData(
        new Invoice({
          ...detail,
          header: {
            ...detail.header,
            invoiceId: PrintReceiptController.invoiceDetailData.header.invoiceId
          }
        })
      );
      await nextTick();
      if (option.key === "pdf_a4") {
        await (this.$refs as any).invoice.downloadPdfA4();
      } else if (option.key === "png_a4") {
        await (this.$refs as any).invoice.downloadPngA4();
      } else if (option.key === "struk") {
        await (this.$refs as any).struk.downloadPdfStruk();
      }
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Gagal mendapatkan detail invoice!", () => {
          MainAppController.closeErrorMessage();
          this.handleDownloadCreateInvoice(option);
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
    PrintReceiptController.activity({
      id: PrintReceiptController.invoiceDetailData.header.invoiceId,
      payload: new ActivityRequest(true)
    });
  }

  get configRuleWoodpacking() {
    return new SttAdjustmentRule({
      rule: "NON_SHOW"
    })
  }

  onCheckFraudNumber() {
    const sender = (this.$refs as any)["booking-v4-sender-section"];
    if (!sender) return;
    sender.onCheckFraudNumber(sender.fullPhoneNumber);
  }
}
export default CreateBookingManualV4;
